// -------------Local URL

// export const apiBaseUrl = `https://uat.madoverbuilding.com`;
//export const apiBaseUrl = `http://127.0.0.1:8000`;

// export const baseUrl = ``;
// export const demandRupifiUrl = `https://mob-demand-side.netlify.app/home/checkout?checkout_url=`;
// export const showDemandRupifiUrl = `https://mob-demand-side.netlify.app`;
// export const stateOptions = [
//   { label: "--Select state--", value: "" },
//   { label: "Karnataka", value: "Karnataka" },
//   { label: "Tamil Nadu", value: "Tamil Nadu" },
// ];

// -------------live url
export const apiBaseUrl =
  `https://mob.madoverbuilding.com` || process.env.REACT_APP_BASE_URL;
export const demandRupifiUrl = `https://madoverbuildings.com/home/checkout?checkout_url=`;
export const showDemandRupifiUrl = `https://madoverbuildings.com`;
export const baseUrl = ``;

// export const demandRupifiUrl = `https://mob-demand-side.netlify.app/home/checkout?checkout_url=`;
// export const showDemandRupifiUrl = `https://mob-demand-side.netlify.app`;

export const gstRegex = /^(?:[0-3|9][0-9])[a-zA-Z0-9]{13}$/;
export const mobileRegex = /^\d{10}$/;
export const checkPhoneNumberValidation = (value) => {
  return mobileRegex.test(value);
};
// export const gstRegex = /^[0-9]{2}[a-zA-z0-9]{13}$/;
export const rupifiStatusCheck = ["ACTIVE", "REJECTED","INACTIVE","PRE_APPROVED","INCOMPLETE","UNDER_REVIEW"];

// Google Maps Configuration
// IMPORTANT: Set REACT_APP_GOOGLE_MAPS_API_KEY in your .env file
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCVLamNquALGHbWCgb-U3-Ab8OdSyhOkEM";

// Google Maps libraries to load
export const GOOGLE_MAPS_LIBRARIES = ["places"];

// Google Maps configuration for cost optimization
export const GOOGLE_MAPS_CONFIG = {
  id: "google-map-script",
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
  // Prevent multiple script loads
  preventGoogleFontsLoading: true,
};

export const PORTER_WEBHOOK_STATUS_MAP = {
  order_accepted: "Accepted",
  order_start_trip: "Out for delivery",
  order_end_job: "Delivered",
  order_reopen: "Requested",
  order_cancel: "Cancelled",
};
export const genderOption = [
  {
    key: 1,
    label: "Male",
    value: "Male",
  },
  {
    key: 2,
    label: "Female",
    value: "Female",
  },
  {
    key: 3,
    label: "Others",
    value: "Others",
  },
];
export const serviceRequestStatusOption = [
  {
    key: 1,
    label: "Registered",
    value: "Registered",
  },
  {
    key: 2,
    label: "In Progress",
    value: "In Progress",
  },
  {
    key: 3,
    label: "Resolved",
    value: "Resolved",
  },
  {
    key: 4,
    label: "Redundant",
    value: "Redundant",
  },
];
export const issueTypeOptions = [
  {key: "1", value: "Damaged Product", label: "Damaged Product"},
  {key: "2", value: "Quantity Issue", label: "Quantity Issue"},
  {key: "3", value: "Wrong Material Sent", label: "Wrong Material Sent"},
  {
    key: "4",
    value: "Under Warranty Service Requests",
    label: "Under Warranty Service Requests",
  },
  {
    key: "5",
    value: "Installation/Working Issue",
    label: "Installation/Working Issue",
  },
  {key: "6", value: "Return Request", label: "Return Request"},
  {key: "7", value: "Invoice Amount Issue", label: "Invoice Amount Issue"},
  {key: "8", value: "Payment Capture Issue", label: "Payment Capture Issue"},
  {key: "9", value: "Replacement Request", label: "Replacement Request"},
  {key: "10", value: "Other", label: "Other"},
];

export const amountType = [
  {
    key: 1,
    label: "Add",
    value: "CREDIT",
  },
  {
    key: 2,
    label: "Deduct",
    value: "DEBIT",
  },
];
export const cityOptions = [
  { key: 1, label: "Agartala", value: "Agartala" },
  { key: 2, label: "Agra", value: "Agra" },
  { key: 3, label: "Ahmedabad", value: "Ahmedabad" },
  { key: 4, label: "Aizawl", value: "Aizawl" },
  { key: 5, label: "Ajmer", value: "Ajmer" },
  { key: 6, label: "Aligarh", value: "Aligarh" },
  { key: 7, label: "Allahabad", value: "Allahabad" },
  { key: 8, label: "Amaravati", value: "Amaravati" },
  { key: 9, label: "Ambala", value: "Ambala" },
  { key: 10, label: "Amravati", value: "Amravati" },
  { key: 11, label: "Amritsar", value: "Amritsar" },
  { key: 12, label: "Asansol", value: "Asansol" },
  { key: 13, label: "Aurangabad", value: "Aurangabad" },
  // { key: 14, label: "Bengaluru", value: "Bengaluru" },
  { key: 15, label: "Bareilly", value: "Bareilly" },
  { key: 16, label: "Belgaum", value: "Belgaum" },
  { key: 17, label: "Bengaluru", value: "Bengaluru" },
  { key: 18, label: "Bhatinda", value: "Bhatinda" },
  { key: 19, label: "Bhavnagar", value: "Bhavnagar" },
  { key: 20, label: "Bhilai", value: "Bhilai" },
  { key: 21, label: "Bhopal", value: "Bhopal" },
  { key: 22, label: "Bhubaneswar", value: "Bhubaneswar" },
  { key: 23, label: "Bikaner", value: "Bikaner" },
  { key: 24, label: "Bilaspur", value: "Bilaspur" },
  { key: 25, label: "Chandigarh", value: "Chandigarh" },
  { key: 26, label: "Chennai", value: "Chennai" },
  { key: 27, label: "Coimbatore", value: "Coimbatore" },
  { key: 28, label: "Cuttack", value: "Cuttack" },
  { key: 29, label: "Dehradun", value: "Dehradun" },
  { key: 30, label: "Delhi", value: "Delhi" },
  { key: 31, label: "Delhi NCR", value: "Delhi NCR" },
  { key: 32, label: "Dhanbad", value: "Dhanbad" },
  { key: 33, label: "Durgapur", value: "Durgapur" },
  { key: 34, label: "Faridabad", value: "Faridabad" },
  { key: 35, label: "Firozabad", value: "Firozabad" },
  { key: 36, label: "Gandhinagar", value: "Gandhinagar" },
  { key: 37, label: "Ghaziabad", value: "Ghaziabad" },
  { key: 38, label: "Gorakhpur", value: "Gorakhpur" },
  { key: 39, label: "Greater Noida", value: "Greater Noida" },
  { key: 40, label: "Guntur", value: "Guntur" },
  { key: 41, label: "Gurugram", value: "Gurugram" },
  { key: 42, label: "Guwahati", value: "Guwahati" },
  { key: 43, label: "Gwalior", value: "Gwalior" },
  { key: 44, label: "Howrah", value: "Howrah" },
  { key: 45, label: "Hubli–Dharwad", value: "Hubli–Dharwad" },
  { key: 46, label: "Hyderabad", value: "Hyderabad" },
  { key: 47, label: "Imphal", value: "Imphal" },
  { key: 48, label: "Indore", value: "Indore" },
  // { key: 49, label: "Itanagar", value: "Itanagar" },
  { key: 50, label: "Jabalpur", value: "Jabalpur" },
  { key: 51, label: "Jaipur", value: "Jaipur" },
  { key: 52, label: "Jalandhar", value: "Jalandhar" },
  { key: 53, label: "Jammu", value: "Jammu" },
  { key: 54, label: "Jamshedpur", value: "Jamshedpur" },
  { key: 55, label: "Jhansi", value: "Jhansi" },
  { key: 56, label: "Jodhpur", value: "Jodhpur" },
  { key: 57, label: "Kalyan-Dombivli", value: "Kalyan-Dombivli" },
  { key: 58, label: "Kanpur", value: "Kanpur" },
  { key: 59, label: "Kavaratti", value: "Kavaratti" },
  { key: 60, label: "Kochi", value: "Kochi" },
  { key: 61, label: "Kolhapur", value: "Kolhapur" },
  { key: 62, label: "Kolkata", value: "Kolkata" },
  { key: 63, label: "Kota", value: "Kota" },
  { key: 64, label: "Kozhikode", value: "Kozhikode" },
  { key: 65, label: "Lucknow", value: "Lucknow" },
  { key: 66, label: "Ludhiana", value: "Ludhiana" },
  { key: 67, label: "Madurai", value: "Madurai" },
  { key: 68, label: "Maheshtala", value: "Maheshtala" },
  { key: 69, label: "Malegaon", value: "Malegaon" },
  { key: 70, label: "Mangalore", value: "Mangalore" },
  { key: 71, label: "Mapusa", value: "Mapusa" },
  { key: 72, label: "Margao", value: "Margao" },
  { key: 73, label: "Meerut", value: "Meerut" },
  { key: 74, label: "Moradabad", value: "Moradabad" },
  { key: 75, label: "Mumbai", value: "Mumbai" },
  { key: 76, label: "Muzaffarnagar", value: "Muzaffarnagar" },
  { key: 77, label: "Muzaffarpur", value: "Muzaffarpur" },
  { key: 78, label: "Mysore", value: "Mysore" },
  { key: 79, label: "Nagpur", value: "Nagpur" },
  { key: 80, label: "Nanded", value: "Nanded" },
  { key: 81, label: "Nashik", value: "Nashik" },
  { key: 82, label: "Navi Mumbai", value: "Navi Mumbai" },
  { key: 83, label: "Noida", value: "Noida" },
  { key: 84, label: "Palakkad", value: "Palakkad" },
  { key: 115, label: "Santoshpur", value: "Santoshpur" },
  { key: 116, label: "Bendravadi", value: "Bendravadi" },
  { key: 117, label: "Kodagihalli", value: "Kodagihalli" },
  { key: 118, label: "Harna Buzurg", value: "Harna Buzurg" },
  { key: 119, label: "Mailanhalli", value: "Mailanhalli" },
  { key: 120, label: "Sultampur", value: "Sultampur" },
  { key: 121, label: "Adakimaranhalli", value: "Adakimaranhalli" },
  { key: 122, label: "Delhi NCR", value: "Delhi NCR" },
  { key: 123, label: "Gurugram", value: "Gurugram" },
  { key: 124, label: "Noida", value: "Noida" },
  { key: 85, label: "Panaji", value: "Panaji" },
  { key: 86, label: "Patna", value: "Patna" },
  { key: 87, label: "Pimpri-Chinchwad", value: "Pimpri-Chinchwad" },
  { key: 88, label: "Puducherry", value: "Puducherry" },
  { key: 89, label: "Pune", value: "Pune" },
  { key: 90, label: "Raipur", value: "Raipur" },
  { key: 91, label: "Rajkot", value: "Rajkot" },
  { key: 92, label: "Ranchi", value: "Ranchi" },
  { key: 93, label: "Saharanpur", value: "Saharanpur" },
  { key: 94, label: "Salem", value: "Salem" },
  { key: 95, label: "Shillong", value: "Shillong" },
  { key: 96, label: "Shimla", value: "Shimla" },
  { key: 97, label: "Siliguri", value: "Siliguri" },
  { key: 98, label: "Solapur", value: "Solapur" },
  { key: 99, label: "Srinagar", value: "Srinagar" },
  { key: 100, label: "Surat", value: "Surat" },
  { key: 101, label: "Thane", value: "Thane" },
  { key: 102, label: "Thiruvananthapuram", value: "Thiruvananthapuram" },
  { key: 103, label: "Tiruchirappalli", value: "Tiruchirappalli" },
  { key: 104, label: "Tirupati", value: "Tirupati" },
  { key: 105, label: "Tiruppur", value: "Tiruppur" },
  { key: 106, label: "Udaipur", value: "Udaipur" },
  { key: 107, label: "Ujjain", value: "Ujjain" },
  { key: 108, label: "Ulhasnagar", value: "Ulhasnagar" },
  { key: 109, label: "Vadodara", value: "Vadodara" },
  { key: 110, label: "Varanasi", value: "Varanasi" },
  { key: 111, label: "Vasai-Virar", value: "Vasai-Virar" },
  { key: 112, label: "Vijayawada", value: "Vijayawada" },
  { key: 113, label: "Visakhapatnam", value: "Visakhapatnam" },
  { key: 114, label: "Warangal", value: "Warangal" },
  // Additional major cities from Andhra Pradesh
  { key: 125, label: "Vijayawada", value: "Vijayawada" },
  { key: 126, label: "Visakhapatnam", value: "Visakhapatnam" },
  { key: 127, label: "Guntur", value: "Guntur" },
  { key: 128, label: "Nellore", value: "Nellore" },
  { key: 129, label: "Kurnool", value: "Kurnool" },
  { key: 130, label: "Rajahmundry", value: "Rajahmundry" },
  { key: 131, label: "Tirupati", value: "Tirupati" },
  { key: 132, label: "Kadapa", value: "Kadapa" },
  { key: 133, label: "Anantapur", value: "Anantapur" },
  // Additional major cities from Delhi
  { key: 134, label: "New Delhi", value: "New Delhi" },
  { key: 135, label: "Dwarka", value: "Dwarka" },
  { key: 136, label: "Rohini", value: "Rohini" },
  { key: 137, label: "Karol Bagh", value: "Karol Bagh" },
  { key: 138, label: "Saket", value: "Saket" },
  { key: 139, label: "Vasant Kunj", value: "Vasant Kunj" },
  // Additional major cities from Karnataka
  { key: 140, label: "Mysuru", value: "Mysuru" },
  { key: 141, label: "Mangaluru", value: "Mangaluru" },
  { key: 142, label: "Hubballi", value: "Hubballi" },
  { key: 143, label: "Belagavi", value: "Belagavi" },
  { key: 144, label: "Davanagere", value: "Davanagere" },
  { key: 145, label: "Ballari", value: "Ballari" },
  { key: 146, label: "Tumakuru", value: "Tumakuru" },
  { key: 147, label: "Shivamogga", value: "Shivamogga" },
  { key: 148, label: "Udupi", value: "Udupi" },
  { key: 149, label: "Raichur", value: "Raichur" },
  { key: 150, label: "Hassan", value: "Hassan" },
  { key: 151, label: "Bidar", value: "Bidar" },
  { key: 152, label: "Hospet", value: "Hospet" },
  { key: 153, label: "Chikkamagaluru", value: "Chikkamagaluru" },
  { key: 154, label: "Bagalkot", value: "Bagalkot" },
  { key: 155, label: "Chitradurga", value: "Chitradurga" },
  // Additional cities from user-provided list
  // Additional major cities from all states/UTs
  { key: 156, label: "Port Blair", value: "Port Blair" },
  { key: 157, label: "Kakinada", value: "Kakinada" },
  { key: 158, label: "Ongole", value: "Ongole" },
  { key: 159, label: "Machilipatnam", value: "Machilipatnam" },
  { key: 160, label: "Eluru", value: "Eluru" },
  { key: 161, label: "Srikakulam", value: "Srikakulam" },
  { key: 162, label: "Vizianagaram", value: "Vizianagaram" },
  { key: 163, label: "Tadepalligudem", value: "Tadepalligudem" },
  { key: 164, label: "Nandyal", value: "Nandyal" },
  { key: 165, label: "Proddatur", value: "Proddatur" },
  { key: 166, label: "Itanagar", value: "Itanagar" },
  { key: 167, label: "Naharlagun", value: "Naharlagun" },
  { key: 168, label: "Pasighat", value: "Pasighat" },
  { key: 169, label: "Tawang", value: "Tawang" },
  { key: 170, label: "Tezu", value: "Tezu" },
  { key: 171, label: "Dibrugarh", value: "Dibrugarh" },
  { key: 172, label: "Silchar", value: "Silchar" },
  { key: 173, label: "Jorhat", value: "Jorhat" },
  { key: 174, label: "Nagaon", value: "Nagaon" },
  { key: 175, label: "Tinsukia", value: "Tinsukia" },
  { key: 176, label: "Dibrugarh", value: "Dibrugarh" },
  { key: 177, label: "Barpeta", value: "Barpeta" },
  { key: 178, label: "Dhubri", value: "Dhubri" },
  { key: 179, label: "Gaya", value: "Gaya" },
  { key: 180, label: "Bhagalpur", value: "Bhagalpur" },
  { key: 181, label: "Muzaffarpur", value: "Muzaffarpur" },
  { key: 182, label: "Purnia", value: "Purnia" },
  { key: 183, label: "Darbhanga", value: "Darbhanga" },
  { key: 184, label: "Arrah", value: "Arrah" },
  { key: 185, label: "Begusarai", value: "Begusarai" },
  { key: 186, label: "Katihar", value: "Katihar" },
  { key: 187, label: "Munger", value: "Munger" },
  { key: 188, label: "Chandigarh", value: "Chandigarh" },
  { key: 189, label: "Bhilai", value: "Bhilai" },
  { key: 190, label: "Bilaspur", value: "Bilaspur" },
  { key: 191, label: "Korba", value: "Korba" },
  { key: 192, label: "Raigarh", value: "Raigarh" },
  { key: 193, label: "Ambikapur", value: "Ambikapur" },
  { key: 194, label: "Jagdalpur", value: "Jagdalpur" },
  { key: 195, label: "Durg", value: "Durg" },
  { key: 196, label: "Goa Velha", value: "Goa Velha" },
  { key: 197, label: "Margao", value: "Margao" },
  { key: 198, label: "Vasco da Gama", value: "Vasco da Gama" },
  { key: 199, label: "Porvorim", value: "Porvorim" },
  { key: 200, label: "Panaji", value: "Panaji" },
  { key: 201, label: "Ahmedabad", value: "Ahmedabad" },
  { key: 202, label: "Surat", value: "Surat" },
  { key: 203, label: "Vadodara", value: "Vadodara" },
  { key: 204, label: "Rajkot", value: "Rajkot" },
  { key: 205, label: "Bhavnagar", value: "Bhavnagar" },
  { key: 206, label: "Jamnagar", value: "Jamnagar" },
  { key: 207, label: "Junagadh", value: "Junagadh" },
  { key: 208, label: "Gandhinagar", value: "Gandhinagar" },
  { key: 209, label: "Anand", value: "Anand" },
  { key: 210, label: "Navsari", value: "Navsari" },
  { key: 211, label: "Himatnagar", value: "Himatnagar" },
  { key: 212, label: "Dahod", value: "Dahod" },
  { key: 213, label: "Bharuch", value: "Bharuch" },
  { key: 214, label: "Ambala", value: "Ambala" },
  { key: 215, label: "Panipat", value: "Panipat" },
  { key: 216, label: "Yamunanagar", value: "Yamunanagar" },
  { key: 217, label: "Rohtak", value: "Rohtak" },
  { key: 218, label: "Hisar", value: "Hisar" },
  { key: 219, label: "Karnal", value: "Karnal" },
  { key: 220, label: "Sonipat", value: "Sonipat" },
  { key: 221, label: "Panchkula", value: "Panchkula" },
  { key: 222, label: "Bhiwani", value: "Bhiwani" },
  { key: 223, label: "Sirsa", value: "Sirsa" },
  { key: 224, label: "Palwal", value: "Palwal" },
  { key: 225, label: "Shimla", value: "Shimla" },
  { key: 226, label: "Solan", value: "Solan" },
  { key: 227, label: "Mandi", value: "Mandi" },
  { key: 228, label: "Dharamshala", value: "Dharamshala" },
  { key: 229, label: "Una", value: "Una" },
  { key: 230, label: "Hamirpur", value: "Hamirpur" },
  { key: 231, label: "Jammu", value: "Jammu" },
  { key: 232, label: "Srinagar", value: "Srinagar" },
  { key: 233, label: "Anantnag", value: "Anantnag" },
  { key: 234, label: "Baramulla", value: "Baramulla" },
  { key: 235, label: "Udhampur", value: "Udhampur" },
  { key: 236, label: "Kathua", value: "Kathua" },
  // { key: 237, label: "Bangalore", value: "Bangalore" },
  { key: 238, label: "Mysore", value: "Mysore" },
  { key: 239, label: "Mangalore", value: "Mangalore" },
  { key: 240, label: "Hubli", value: "Hubli" },
  { key: 241, label: "Belgaum", value: "Belgaum" },
  { key: 242, label: "Davanagere", value: "Davanagere" },
  { key: 243, label: "Bellary", value: "Bellary" },
  { key: 244, label: "Tumkur", value: "Tumkur" },
  { key: 245, label: "Shimoga", value: "Shimoga" },
  { key: 246, label: "Bidar", value: "Bidar" },
  { key: 247, label: "Hospet", value: "Hospet" },
  { key: 248, label: "Hassan", value: "Hassan" },
  { key: 249, label: "Udupi", value: "Udupi" },
  { key: 250, label: "Mandya", value: "Mandya" },
  { key: 251, label: "Kolar", value: "Kolar" },
  { key: 252, label: "Chikmagalur", value: "Chikmagalur" },
  { key: 253, label: "Gulbarga", value: "Gulbarga" },
  { key: 254, label: "Kerala", value: "Kerala" },
  // { key: 255, label: "Thiruvananthapuram", value: "Thiruvananthapuram" },
  { key: 256, label: "Kochi", value: "Kochi" },
  { key: 257, label: "Kozhikode", value: "Kozhikode" },
  { key: 258, label: "Kollam", value: "Kollam" },
  { key: 259, label: "Thrissur", value: "Thrissur" },
  { key: 260, label: "Alappuzha", value: "Alappuzha" },
  { key: 261, label: "Palakkad", value: "Palakkad" },
  { key: 262, label: "Malappuram", value: "Malappuram" },
  { key: 263, label: "Kottayam", value: "Kottayam" },
  { key: 264, label: "Pathanamthitta", value: "Pathanamthitta" },
  { key: 265, label: "Kannur", value: "Kannur" },
  { key: 266, label: "Kasaragod", value: "Kasaragod" },
  { key: 267, label: "Idukki", value: "Idukki" },
  { key: 268, label: "Bhopal", value: "Bhopal" },
  { key: 269, label: "Indore", value: "Indore" },
  { key: 270, label: "Jabalpur", value: "Jabalpur" },
  { key: 271, label: "Gwalior", value: "Gwalior" },
  { key: 272, label: "Ujjain", value: "Ujjain" },
  { key: 273, label: "Sagar", value: "Sagar" },
  { key: 274, label: "Dewas", value: "Dewas" },
  { key: 275, label: "Satna", value: "Satna" },
  { key: 276, label: "Ratlam", value: "Ratlam" },
  { key: 277, label: "Rewa", value: "Rewa" },
  { key: 278, label: "Murwara", value: "Murwara" },
  { key: 279, label: "Katni", value: "Katni" },
  { key: 280, label: "Singrauli", value: "Singrauli" },
  { key: 281, label: "Mumbai", value: "Mumbai" },
  { key: 282, label: "Pune", value: "Pune" },
  { key: 283, label: "Nagpur", value: "Nagpur" },
  { key: 284, label: "Nashik", value: "Nashik" },
  { key: 285, label: "Thane", value: "Thane" },
  { key: 286, label: "Aurangabad", value: "Aurangabad" },
  { key: 287, label: "Solapur", value: "Solapur" },
  { key: 288, label: "Amravati", value: "Amravati" },
  { key: 289, label: "Nanded", value: "Nanded" },
  { key: 290, label: "Kolhapur", value: "Kolhapur" },
  { key: 291, label: "Sangli", value: "Sangli" },
  { key: 292, label: "Jalgaon", value: "Jalgaon" },
  { key: 293, label: "Akola", value: "Akola" },
  { key: 294, label: "Latur", value: "Latur" },
  { key: 295, label: "Dhule", value: "Dhule" },
  { key: 296, label: "Ahmednagar", value: "Ahmednagar" },
  { key: 297, label: "Parbhani", value: "Parbhani" },
  { key: 298, label: "Imphal", value: "Imphal" },
  { key: 299, label: "Shillong", value: "Shillong" },
  { key: 300, label: "Aizawl", value: "Aizawl" },
  { key: 301, label: "Kohima", value: "Kohima" },
  { key: 302, label: "Dimapur", value: "Dimapur" },
  { key: 303, label: "Bhubaneswar", value: "Bhubaneswar" },
  { key: 304, label: "Cuttack", value: "Cuttack" },
  { key: 305, label: "Rourkela", value: "Rourkela" },
  { key: 306, label: "Brahmapur", value: "Brahmapur" },
  { key: 307, label: "Sambalpur", value: "Sambalpur" },
  { key: 308, label: "Puri", value: "Puri" },
  { key: 309, label: "Balasore", value: "Balasore" },
  { key: 310, label: "Baripada", value: "Baripada" },
  { key: 311, label: "Jeypore", value: "Jeypore" },
  { key: 312, label: "Puducherry", value: "Puducherry" },
  { key: 313, label: "Karaikal", value: "Karaikal" },
  { key: 314, label: "Yanam", value: "Yanam" },
  { key: 315, label: "Mahe", value: "Mahe" },
  { key: 316, label: "Ludhiana", value: "Ludhiana" },
  { key: 317, label: "Amritsar", value: "Amritsar" },
  { key: 318, label: "Jalandhar", value: "Jalandhar" },
  { key: 319, label: "Patiala", value: "Patiala" },
  { key: 320, label: "Bathinda", value: "Bathinda" },
  { key: 321, label: "Mohali", value: "Mohali" },
  { key: 322, label: "Hoshiarpur", value: "Hoshiarpur" },
  { key: 323, label: "Pathankot", value: "Pathankot" },
  { key: 324, label: "Moga", value: "Moga" },
  { key: 325, label: "Phagwara", value: "Phagwara" },
  { key: 326, label: "Jaipur", value: "Jaipur" },
  { key: 327, label: "Jodhpur", value: "Jodhpur" },
  { key: 328, label: "Kota", value: "Kota" },
  { key: 329, label: "Bikaner", value: "Bikaner" },
  { key: 330, label: "Ajmer", value: "Ajmer" },
  { key: 331, label: "Udaipur", value: "Udaipur" },
  { key: 332, label: "Bhilwara", value: "Bhilwara" },
  { key: 333, label: "Alwar", value: "Alwar" },
  { key: 334, label: "Sikar", value: "Sikar" },
  { key: 335, label: "Pali", value: "Pali" },
  { key: 336, label: "Sri Ganganagar", value: "Sri Ganganagar" },
  { key: 337, label: "Sikkim", value: "Sikkim" },
  { key: 338, label: "Gangtok", value: "Gangtok" },
  { key: 339, label: "Namchi", value: "Namchi" },
  { key: 340, label: "Mangan", value: "Mangan" },
  { key: 341, label: "Chennai", value: "Chennai" },
  { key: 342, label: "Coimbatore", value: "Coimbatore" },
  { key: 343, label: "Madurai", value: "Madurai" },
  { key: 344, label: "Tiruchirappalli", value: "Tiruchirappalli" },
  { key: 345, label: "Salem", value: "Salem" },
  { key: 346, label: "Tirunelveli", value: "Tirunelveli" },
  { key: 347, label: "Tiruppur", value: "Tiruppur" },
  { key: 348, label: "Vellore", value: "Vellore" },
  { key: 349, label: "Erode", value: "Erode" },
  { key: 350, label: "Dindigul", value: "Dindigul" },
  { key: 351, label: "Thanjavur", value: "Thanjavur" },
  { key: 352, label: "Nagercoil", value: "Nagercoil" },
  { key: 353, label: "Kanchipuram", value: "Kanchipuram" },
  { key: 354, label: "Karur", value: "Karur" },
  { key: 355, label: "Telangana", value: "Telangana" },
  { key: 356, label: "Hyderabad", value: "Hyderabad" },
  { key: 357, label: "Warangal", value: "Warangal" },
  { key: 358, label: "Nizamabad", value: "Nizamabad" },
  { key: 359, label: "Karimnagar", value: "Karimnagar" },
  { key: 360, label: "Ramagundam", value: "Ramagundam" },
  { key: 361, label: "Khammam", value: "Khammam" },
  { key: 362, label: "Mahbubnagar", value: "Mahbubnagar" },
  { key: 363, label: "Adilabad", value: "Adilabad" },
  { key: 364, label: "Suryapet", value: "Suryapet" },
  { key: 365, label: "Siddipet", value: "Siddipet" },
  { key: 366, label: "Tripura", value: "Tripura" },
  { key: 367, label: "Agartala", value: "Agartala" },
  { key: 368, label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { key: 369, label: "Lucknow", value: "Lucknow" },
  { key: 370, label: "Kanpur", value: "Kanpur" },
  { key: 371, label: "Ghaziabad", value: "Ghaziabad" },
  { key: 372, label: "Agra", value: "Agra" },
  { key: 373, label: "Varanasi", value: "Varanasi" },
  { key: 374, label: "Meerut", value: "Meerut" },
  { key: 375, label: "Allahabad", value: "Allahabad" },
  { key: 376, label: "Bareilly", value: "Bareilly" },
  { key: 377, label: "Aligarh", value: "Aligarh" },
  { key: 378, label: "Moradabad", value: "Moradabad" },
  { key: 379, label: "Saharanpur", value: "Saharanpur" },
  { key: 380, label: "Gorakhpur", value: "Gorakhpur" },
  { key: 381, label: "Firozabad", value: "Firozabad" },
  { key: 382, label: "Jhansi", value: "Jhansi" },
  { key: 383, label: "Muzaffarnagar", value: "Muzaffarnagar" },
  { key: 384, label: "Mathura", value: "Mathura" },
  { key: 385, label: "Budaun", value: "Budaun" },
  { key: 386, label: "Uttarakhand", value: "Uttarakhand" },
  { key: 387, label: "Dehradun", value: "Dehradun" },
  { key: 388, label: "Haridwar", value: "Haridwar" },
  { key: 389, label: "Roorkee", value: "Roorkee" },
  { key: 390, label: "Haldwani", value: "Haldwani" },
  { key: 391, label: "Rudrapur", value: "Rudrapur" },
  { key: 392, label: "Kashipur", value: "Kashipur" },
  { key: 393, label: "Rishikesh", value: "Rishikesh" },
  { key: 394, label: "West Bengal", value: "West Bengal" },
  { key: 395, label: "Kolkata", value: "Kolkata" },
  { key: 396, label: "Howrah", value: "Howrah" },
  { key: 397, label: "Durgapur", value: "Durgapur" },
  { key: 398, label: "Asansol", value: "Asansol" },
  { key: 399, label: "Siliguri", value: "Siliguri" },
  { key: 400, label: "Maheshtala", value: "Maheshtala" },
  { key: 401, label: "Rajpur Sonarpur", value: "Rajpur Sonarpur" },
  { key: 402, label: "South Dumdum", value: "South Dumdum" },
  { key: 403, label: "Bhatpara", value: "Bhatpara" },
  { key: 404, label: "Kamarhati", value: "Kamarhati" },
  { key: 405, label: "Baranagar", value: "Baranagar" },
  { key: 406, label: "Bardhaman", value: "Bardhaman" },
  { key: 407, label: "Kharagpur", value: "Kharagpur" },
  { key: 408, label: "Haldia", value: "Haldia" },
  { key: 409, label: "Malda", value: "Malda" },
  { key: 410, label: "Bankura", value: "Bankura" },
  { key: 411, label: "Darjeeling", value: "Darjeeling" },
  { key: 412, label: "Raiganj", value: "Raiganj" },
  { key: 413, label: "Krishnanagar", value: "Krishnanagar" },
  { key: 414, label: "Bongaon", value: "Bongaon" },
  { key: 415, label: "Cooch Behar", value: "Cooch Behar" },
  { key: 416, label: "Jalpaiguri", value: "Jalpaiguri" },
  { key: 417, label: "Kalyani", value: "Kalyani" },
  { key: 418, label: "Bansberia", value: "Bansberia" },
  { key: 419, label: "Baidyabati", value: "Baidyabati" },
  { key: 420, label: "North Dumdum", value: "North Dumdum" },
  // Additional major cities from Gujarat
  { key: 421, label: "Gandhidham", value: "Gandhidham" },
  { key: 422, label: "Nadiad", value: "Nadiad" },
  { key: 423, label: "Morbi", value: "Morbi" },
  { key: 424, label: "Surendranagar", value: "Surendranagar" },
  { key: 425, label: "Mehsana", value: "Mehsana" },
  { key: 426, label: "Bhuj", value: "Bhuj" },
  { key: 427, label: "Porbandar", value: "Porbandar" },
  { key: 428, label: "Vapi", value: "Vapi" },
  { key: 429, label: "Godhra", value: "Godhra" },
  { key: 430, label: "Veraval", value: "Veraval" },
  { key: 431, label: "Valsad", value: "Valsad" },
  { key: 432, label: "Ankleshwar", value: "Ankleshwar" },
  { key: 433, label: "Ananthapuramu", value: "Ananthapuramu" },
  { key: 434, label: "Chittoor", value: "Chittoor" },
  { key: 435, label: "Hindupur", value: "Hindupur" },
  { key: 436, label: "Tenali", value: "Tenali" },
  { key: 437, label: "Adoni", value: "Adoni" },
  { key: 438, label: "Tirumala", value: "Tirumala" },
  { key: 439, label: "Srikalahasti", value: "Srikalahasti" },
  { key: 440, label: "Bomdila", value: "Bomdila" },
  { key: 441, label: "Ziro", value: "Ziro" },
  { key: 442, label: "Roing", value: "Roing" },
  { key: 443, label: "Aalo", value: "Aalo" },
  { key: 444, label: "Namsai", value: "Namsai" },
  { key: 445, label: "Tezpur", value: "Tezpur" },
  { key: 446, label: "Bongaigaon", value: "Bongaigaon" },
  { key: 447, label: "Sivasagar", value: "Sivasagar" },
  { key: 448, label: "Karimganj", value: "Karimganj" },
  { key: 449, label: "Goalpara", value: "Goalpara" },
  { key: 450, label: "Dhemaji", value: "Dhemaji" },
  { key: 451, label: "Purnea", value: "Purnea" },
  { key: 452, label: "Siwan", value: "Siwan" },
  { key: 453, label: "Samastipur", value: "Samastipur" },
  { key: 454, label: "Bettiah", value: "Bettiah" },
  { key: 455, label: "Buxar", value: "Buxar" },
  { key: 456, label: "Sasaram", value: "Sasaram" },
  { key: 457, label: "Motihari", value: "Motihari" },
  { key: 458, label: "Chhapra", value: "Chhapra" },
  { key: 459, label: "Kishanganj", value: "Kishanganj" },
  { key: 460, label: "Bilaspur (HP)", value: "Bilaspur (HP)" },
  { key: 461, label: "Kullu", value: "Kullu" },
  { key: 462, label: "Manali", value: "Manali" },
  { key: 463, label: "Nahan", value: "Nahan" },
  { key: 464, label: "Chamba", value: "Chamba" },
  { key: 465, label: "Kangra", value: "Kangra" },
  { key: 466, label: "Kinnaur", value: "Kinnaur" },
  { key: 467, label: "Bokaro", value: "Bokaro" },
  { key: 468, label: "Hazaribagh", value: "Hazaribagh" },
  { key: 469, label: "Deoghar", value: "Deoghar" },
  { key: 470, label: "Giridih", value: "Giridih" },
  { key: 471, label: "Dumka", value: "Dumka" },
  { key: 472, label: "Daltonganj", value: "Daltonganj" },
  { key: 473, label: "Kalaburagi", value: "Kalaburagi" },
  { key: 474, label: "Vijayapura", value: "Vijayapura" },
  { key: 475, label: "Yadgir", value: "Yadgir" },
  { key: 476, label: "Karwar", value: "Karwar" },
  { key: 477, label: "Gadag", value: "Gadag" },
  { key: 478, label: "Koppal", value: "Koppal" },
  { key: 479, label: "Chamarajanagar", value: "Chamarajanagar" },
  { key: 480, label: "Madikeri", value: "Madikeri" },
  { key: 481, label: "Kanniyakumari", value: "Kanniyakumari" },
  { key: 482, label: "Cuddalore", value: "Cuddalore" },
  { key: 483, label: "Thoothukudi", value: "Thoothukudi" },
  { key: 484, label: "Sivakasi", value: "Sivakasi" },
  { key: 485, label: "Namakkal", value: "Namakkal" },
  { key: 486, label: "Hosur", value: "Hosur" },
  { key: 487, label: "Kumbakonam", value: "Kumbakonam" },
  { key: 488, label: "Nagapattinam", value: "Nagapattinam" },
  { key: 489, label: "Tenkasi", value: "Tenkasi" },
  { key: 490, label: "Pudukkottai", value: "Pudukkottai" },
  { key: 491, label: "Perambalur", value: "Perambalur" },
  { key: 492, label: "Ashta", value: "Ashta" },
  { key: 493, label: "Burhanpur", value: "Burhanpur" },
  { key: 494, label: "Chhindwara", value: "Chhindwara" },
  { key: 495, label: "Khandwa", value: "Khandwa" },
  { key: 496, label: "Sehore", value: "Sehore" },
  { key: 497, label: "Vidisha", value: "Vidisha" },
  { key: 498, label: "Mandsaur", value: "Mandsaur" },
  { key: 499, label: "Neemuch", value: "Neemuch" },
  { key: 500, label: "Shivpuri", value: "Shivpuri" },
  { key: 501, label: "Guna", value: "Guna" },
  { key: 502, label: "Narsinghpur", value: "Narsinghpur" },
  { key: 503, label: "Mandla", value: "Mandla" },
  { key: 504, label: "Betul", value: "Betul" },
  { key: 505, label: "Chhatrapati Sambhajinagar", value: "Chhatrapati Sambhajinagar" },
  { key: 506, label: "Jalna", value: "Jalna" },
  { key: 507, label: "Beed", value: "Beed" },
  { key: 508, label: "Bhandara", value: "Bhandara" },
  { key: 509, label: "Gondia", value: "Gondia" },
  { key: 510, label: "Wardha", value: "Wardha" },
  { key: 511, label: "Yavatmal", value: "Yavatmal" },
  { key: 512, label: "Washim", value: "Washim" },
  { key: 513, label: "Hingoli", value: "Hingoli" },
  { key: 514, label: "Osmanabad", value: "Osmanabad" },
  { key: 515, label: "Panvel", value: "Panvel" },
  { key: 516, label: "Satara", value: "Satara" },
  { key: 517, label: "Ratnagiri", value: "Ratnagiri" },
  { key: 518, label: "Sindhudurg", value: "Sindhudurg" },
  { key: 519, label: "Chiplun", value: "Chiplun" },
  { key: 520, label: "Balangir", value: "Balangir" },
  { key: 521, label: "Bhadrak", value: "Bhadrak" },
  { key: 522, label: "Jajpur", value: "Jajpur" },
  { key: 523, label: "Angul", value: "Angul" },
  { key: 524, label: "Keonjhar", value: "Keonjhar" },
  { key: 525, label: "Phulbani", value: "Phulbani" },
  { key: 526, label: "Kendrapara", value: "Kendrapara" },
  { key: 527, label: "Rayagada", value: "Rayagada" },
  { key: 528, label: "Koraput", value: "Koraput" },
  { key: 529, label: "Bargarh", value: "Bargarh" },
  { key: 530, label: "Abohar", value: "Abohar" },
  { key: 531, label: "Barnala", value: "Barnala" },
  { key: 532, label: "Ferozepur", value: "Ferozepur" },
  { key: 533, label: "Gurdaspur", value: "Gurdaspur" },
  { key: 534, label: "Sangrur", value: "Sangrur" },
  { key: 535, label: "Malerkotla", value: "Malerkotla" },
  { key: 536, label: "Batala", value: "Batala" },
  { key: 537, label: "Churu", value: "Churu" },
  { key: 538, label: "Barmer", value: "Barmer" },
  { key: 539, label: "Jaisalmer", value: "Jaisalmer" },
  { key: 540, label: "Tonk", value: "Tonk" },
  { key: 541, label: "Nagaur", value: "Nagaur" },
  { key: 542, label: "Dausa", value: "Dausa" },
  { key: 543, label: "Bharatpur", value: "Bharatpur" },
  { key: 544, label: "Hanumangarh", value: "Hanumangarh" },
  { key: 545, label: "Banswara", value: "Banswara" },
  { key: 546, label: "Chittorgarh", value: "Chittorgarh" },
  { key: 547, label: "Dholpur", value: "Dholpur" },
  { key: 548, label: "Jhunjhunu", value: "Jhunjhunu" },
  { key: 549, label: "Nalgonda", value: "Nalgonda" },
  { key: 550, label: "Kothagudem", value: "Kothagudem" },
  { key: 551, label: "Miryalaguda", value: "Miryalaguda" },
  { key: 552, label: "Jagtial", value: "Jagtial" },
  { key: 553, label: "Mancherial", value: "Mancherial" },
  { key: 554, label: "Kamareddy", value: "Kamareddy" },
  { key: 555, label: "Sangareddy", value: "Sangareddy" },
  { key: 556, label: "Medak", value: "Medak" },
  { key: 557, label: "Ayodhya", value: "Ayodhya" },
  { key: 558, label: "Prayagraj", value: "Prayagraj" },
  { key: 559, label: "Gautam Buddha Nagar", value: "Gautam Buddha Nagar" },
  { key: 560, label: "Amroha", value: "Amroha" },
  { key: 561, label: "Etawah", value: "Etawah" },
  { key: 562, label: "Rampur", value: "Rampur" },
  { key: 563, label: "Shahjahanpur", value: "Shahjahanpur" },
  { key: 564, label: "Faizabad", value: "Faizabad" },
  { key: 565, label: "Basti", value: "Basti" },
  { key: 566, label: "Bahraich", value: "Bahraich" },
  { key: 567, label: "Sitapur", value: "Sitapur" },
  { key: 568, label: "Lakhimpur", value: "Lakhimpur" },
  { key: 569, label: "Unnao", value: "Unnao" },
  { key: 570, label: "Raebareli", value: "Raebareli" },
  { key: 571, label: "Gonda", value: "Gonda" },
  { key: 572, label: "Deoria", value: "Deoria" },
  { key: 573, label: "Ballia", value: "Ballia" },
  { key: 574, label: "Mau", value: "Mau" },
  { key: 575, label: "Azamgarh", value: "Azamgarh" },
  { key: 576, label: "Mirzapur", value: "Mirzapur" },
  { key: 577, label: "Sonbhadra", value: "Sonbhadra" },
  { key: 578, label: "Nainital", value: "Nainital" },
  { key: 579, label: "Pithoragarh", value: "Pithoragarh" },
  { key: 580, label: "Almora", value: "Almora" },
  { key: 581, label: "Chamoli", value: "Chamoli" },
  { key: 582, label: "Bageshwar", value: "Bageshwar" },
  { key: 583, label: "Tehri", value: "Tehri" },
  { key: 584, label: "Uttarkashi", value: "Uttarkashi" },
  { key: 585, label: "Serampore", value: "Serampore" },
  { key: 586, label: "Chandannagar", value: "Chandannagar" },
  { key: 587, label: "Purulia", value: "Purulia" },
  { key: 588, label: "Midnapore", value: "Midnapore" },
  { key: 589, label: "Nabadwip", value: "Nabadwip" },
  { key: 590, label: "Berhampore", value: "Berhampore" },
  { key: 591, label: "Dum Dum", value: "Dum Dum" },
  { key: 592, label: "Habra", value: "Habra" },
  { key: 593, label: "English Bazar", value: "English Bazar" },
  { key: 594, label: "Leh", value: "Leh" },
  { key: 595, label: "Kargil", value: "Kargil" },
  { key: 596, label: "Silvassa", value: "Silvassa" },
  { key: 597, label: "Daman", value: "Daman" },
  { key: 598, label: "Diu", value: "Diu" },
  { key: 599, label: "Amalapuram", value: "Amalapuram" },
  { key: 600, label: "Bhimavaram", value: "Bhimavaram" },
  { key: 601, label: "Gudivada", value: "Gudivada" },
  { key: 602, label: "Narasaraopet", value: "Narasaraopet" },
  { key: 603, label: "Tadipatri", value: "Tadipatri" },
  { key: 604, label: "Dharmavaram", value: "Dharmavaram" },
  { key: 605, label: "Madanapalle", value: "Madanapalle" },
  { key: 606, label: "Sullurpeta", value: "Sullurpeta" },
  { key: 607, label: "Palasa", value: "Palasa" },
  { key: 608, label: "Narsapur", value: "Narsapur" },
  { key: 609, label: "Seppa", value: "Seppa" },
  { key: 610, label: "Khonsa", value: "Khonsa" },
  { key: 611, label: "Yingkiong", value: "Yingkiong" },
  { key: 612, label: "Daporijo", value: "Daporijo" },
  { key: 613, label: "Changlang", value: "Changlang" },
  { key: 614, label: "Golaghat", value: "Golaghat" },
  { key: 615, label: "Diphu", value: "Diphu" },
  { key: 616, label: "Hailakandi", value: "Hailakandi" },
  { key: 617, label: "Mangaldoi", value: "Mangaldoi" },
  { key: 618, label: "Morigaon", value: "Morigaon" },
  { key: 619, label: "Udalguri", value: "Udalguri" },
  { key: 620, label: "Jehanabad", value: "Jehanabad" },
  { key: 621, label: "Jamui", value: "Jamui" },
  { key: 622, label: "Madhubani", value: "Madhubani" },
  { key: 623, label: "Supaul", value: "Supaul" },
  { key: 624, label: "Saharsa", value: "Saharsa" },
  { key: 625, label: "Araria", value: "Araria" },
  { key: 626, label: "Gopalganj", value: "Gopalganj" },
  { key: 627, label: "Nawada", value: "Nawada" },
  { key: 628, label: "Kawardha", value: "Kawardha" },
  { key: 629, label: "Dhamtari", value: "Dhamtari" },
  { key: 630, label: "Mahasamund", value: "Mahasamund" },
  { key: 631, label: "Kanker", value: "Kanker" },
  { key: 632, label: "Dongargarh", value: "Dongargarh" },
  { key: 633, label: "Rajnandgaon", value: "Rajnandgaon" },
  { key: 634, label: "Kondagaon", value: "Kondagaon" },
  { key: 635, label: "Bijapur", value: "Bijapur" },
  { key: 636, label: "Ponda", value: "Ponda" },
  { key: 637, label: "Bicholim", value: "Bicholim" },
  { key: 638, label: "Canacona", value: "Canacona" },
  { key: 639, label: "Curchorem", value: "Curchorem" },
  { key: 640, label: "Patan", value: "Patan" },
  { key: 641, label: "Palanpur", value: "Palanpur" },
  { key: 642, label: "Botad", value: "Botad" },
  { key: 643, label: "Amreli", value: "Amreli" },
  { key: 644, label: "Somnath", value: "Somnath" },
  { key: 645, label: "Modasa", value: "Modasa" },
  { key: 646, label: "Vyara", value: "Vyara" },
  { key: 647, label: "Kalol", value: "Kalol" },
  { key: 648, label: "Jetpur", value: "Jetpur" },
  { key: 649, label: "Rewari", value: "Rewari" },
  { key: 650, label: "Kaithal", value: "Kaithal" },
  { key: 651, label: "Jind", value: "Jind" },
  { key: 652, label: "Fatehabad", value: "Fatehabad" },
  { key: 653, label: "Kurukshetra", value: "Kurukshetra" },
  { key: 654, label: "Bahadurgarh", value: "Bahadurgarh" },
  { key: 655, label: "Narnaul", value: "Narnaul" },
  { key: 656, label: "Ratia", value: "Ratia" },
  { key: 657, label: "Palampur", value: "Palampur" },
  { key: 658, label: "Baddi", value: "Baddi" },
  { key: 659, label: "Sundarnagar", value: "Sundarnagar" },
  { key: 660, label: "Paonta Sahib", value: "Paonta Sahib" },
  { key: 661, label: "Keylong", value: "Keylong" },
  { key: 662, label: "Ramgarh", value: "Ramgarh" },
  { key: 663, label: "Jamtara", value: "Jamtara" },
  { key: 664, label: "Chaibasa", value: "Chaibasa" },
  { key: 665, label: "Lohardaga", value: "Lohardaga" },
  { key: 666, label: "Khunti", value: "Khunti" },
  { key: 667, label: "Simdega", value: "Simdega" },
  { key: 668, label: "Godda", value: "Godda" },
  { key: 669, label: "Pakur", value: "Pakur" },
  { key: 670, label: "Dharwad", value: "Dharwad" },
  { key: 671, label: "Chikkaballapur", value: "Chikkaballapur" },
  { key: 672, label: "Ramanagara", value: "Ramanagara" },
  { key: 673, label: "Haveri", value: "Haveri" },
  { key: 674, label: "Sirsi", value: "Sirsi" },
  { key: 675, label: "Uttara Kannada", value: "Uttara Kannada" },
  { key: 676, label: "Kottarakkara", value: "Kottarakkara" },
  { key: 677, label: "Nedumangad", value: "Nedumangad" },
  { key: 678, label: "Kayamkulam", value: "Kayamkulam" },
  { key: 679, label: "Ponnani", value: "Ponnani" },
  { key: 680, label: "Payyanur", value: "Payyanur" },
  { key: 681, label: "Taliparamba", value: "Taliparamba" },
  { key: 682, label: "Datia", value: "Datia" },
  { key: 683, label: "Morena", value: "Morena" },
  { key: 684, label: "Bhind", value: "Bhind" },
  { key: 685, label: "Shajapur", value: "Shajapur" },
  { key: 686, label: "Hoshangabad", value: "Hoshangabad" },
  { key: 687, label: "Damoh", value: "Damoh" },
  { key: 688, label: "Seoni", value: "Seoni" },
  { key: 689, label: "Balaghat", value: "Balaghat" },
  { key: 690, label: "Shahdol", value: "Shahdol" },
  { key: 691, label: "Tikamgarh", value: "Tikamgarh" },
  { key: 692, label: "Virar", value: "Virar" },
  { key: 693, label: "Kalyan", value: "Kalyan" },
  { key: 694, label: "Dombivli", value: "Dombivli" },
  { key: 695, label: "Mira Bhayandar", value: "Mira Bhayandar" },
  { key: 696, label: "Karad", value: "Karad" },
  { key: 697, label: "Baramati", value: "Baramati" },
  { key: 698, label: "Pandharpur", value: "Pandharpur" },
  { key: 699, label: "Ichalkaranji", value: "Ichalkaranji" },
  { key: 700, label: "Udgir", value: "Udgir" },
  { key: 701, label: "Shrirampur", value: "Shrirampur" },
  { key: 702, label: "Thoubal", value: "Thoubal" },
  { key: 703, label: "Churachandpur", value: "Churachandpur" },
  { key: 704, label: "Kakching", value: "Kakching" },
  { key: 705, label: "Bishnupur", value: "Bishnupur" },
  { key: 706, label: "Senapati", value: "Senapati" },
  { key: 707, label: "Tura", value: "Tura" },
  { key: 708, label: "Jowai", value: "Jowai" },
  { key: 709, label: "Nongpoh", value: "Nongpoh" },
  { key: 710, label: "Baghmara", value: "Baghmara" },
  { key: 711, label: "Williamnagar", value: "Williamnagar" },
  { key: 712, label: "Lunglei", value: "Lunglei" },
  { key: 713, label: "Champhai", value: "Champhai" },
  { key: 714, label: "Kolasib", value: "Kolasib" },
  { key: 715, label: "Serchhip", value: "Serchhip" },
  { key: 716, label: "Lawngtlai", value: "Lawngtlai" },
  { key: 717, label: "Mokokchung", value: "Mokokchung" },
  { key: 718, label: "Wokha", value: "Wokha" },
  { key: 719, label: "Tuensang", value: "Tuensang" },
  { key: 720, label: "Mon", value: "Mon" },
  { key: 721, label: "Phek", value: "Phek" },
  { key: 722, label: "Paradeep", value: "Paradeep" },
  { key: 723, label: "Dhenkanal", value: "Dhenkanal" },
  { key: 724, label: "Kalahandi", value: "Kalahandi" },
  { key: 725, label: "Nabarangpur", value: "Nabarangpur" },
  { key: 726, label: "Jharsuguda", value: "Jharsuguda" },
  { key: 727, label: "Nuapada", value: "Nuapada" },
  { key: 728, label: "Sundargarh", value: "Sundargarh" },
  { key: 729, label: "Talcher", value: "Talcher" },
  { key: 730, label: "Rupnagar", value: "Rupnagar" },
  { key: 731, label: "Faridkot", value: "Faridkot" },
  { key: 732, label: "Muktsar", value: "Muktsar" },
  { key: 733, label: "Nawanshahr", value: "Nawanshahr" },
  { key: 734, label: "Tarn Taran", value: "Tarn Taran" },
  { key: 735, label: "Kapurthala", value: "Kapurthala" },
  { key: 736, label: "Mansa", value: "Mansa" },
  { key: 737, label: "Fazilka", value: "Fazilka" },
  { key: 738, label: "Beawar", value: "Beawar" },
  { key: 739, label: "Kishangarh", value: "Kishangarh" },
  { key: 740, label: "Sawai Madhopur", value: "Sawai Madhopur" },
  { key: 741, label: "Jhalawar", value: "Jhalawar" },
  { key: 742, label: "Baran", value: "Baran" },
  { key: 743, label: "Pratapgarh", value: "Pratapgarh" },
  { key: 744, label: "Sirohi", value: "Sirohi" },
  { key: 745, label: "Jalore", value: "Jalore" },
  { key: 746, label: "Didwana", value: "Didwana" },
  { key: 747, label: "Gyalshing", value: "Gyalshing" },
  { key: 748, label: "Rangpo", value: "Rangpo" },
  { key: 749, label: "Singtam", value: "Singtam" },
  { key: 750, label: "Pakyong", value: "Pakyong" },
  { key: 751, label: "Jorethang", value: "Jorethang" },
  { key: 752, label: "Ariyalur", value: "Ariyalur" },
  { key: 753, label: "Mayiladuthurai", value: "Mayiladuthurai" },
  { key: 754, label: "Virudhunagar", value: "Virudhunagar" },
  { key: 755, label: "Sankarankoil", value: "Sankarankoil" },
  { key: 756, label: "Pollachi", value: "Pollachi" },
  { key: 757, label: "Udumalaipettai", value: "Udumalaipettai" },
  { key: 758, label: "Kovilpatti", value: "Kovilpatti" },
  { key: 759, label: "Thoothukudi Port", value: "Thoothukudi Port" },
  { key: 760, label: "Tiruvallur", value: "Tiruvallur" },
  { key: 761, label: "Ranipet", value: "Ranipet" },
  { key: 762, label: "Jangaon", value: "Jangaon" },
  { key: 763, label: "Bhupalpally", value: "Bhupalpally" },
  { key: 764, label: "Mahabubabad", value: "Mahabubabad" },
  { key: 765, label: "Vikarabad", value: "Vikarabad" },
  { key: 766, label: "Nirmal", value: "Nirmal" },
  { key: 767, label: "Wanaparthy", value: "Wanaparthy" },
  { key: 768, label: "Nagarkurnool", value: "Nagarkurnool" },
  { key: 769, label: "Asifabad", value: "Asifabad" },
  { key: 770, label: "Udaipur (Tripura)", value: "Udaipur (Tripura)" },
  { key: 771, label: "Dharmanagar", value: "Dharmanagar" },
  { key: 772, label: "Kailasahar", value: "Kailasahar" },
  { key: 773, label: "Belonia", value: "Belonia" },
  { key: 774, label: "Khowai", value: "Khowai" },
  { key: 775, label: "Hapur", value: "Hapur" },
  { key: 776, label: "Pilibhit", value: "Pilibhit" },
  { key: 777, label: "Kasganj", value: "Kasganj" },
  { key: 778, label: "Mainpuri", value: "Mainpuri" },
  { key: 779, label: "Fatehpur", value: "Fatehpur" },
  { key: 780, label: "Hardoi", value: "Hardoi" },
  { key: 781, label: "Sultanpur", value: "Sultanpur" },
  { key: 782, label: "Jaunpur", value: "Jaunpur" },
  { key: 783, label: "Kannauj", value: "Kannauj" },
  { key: 784, label: "Auraiya", value: "Auraiya" },
  { key: 785, label: "Chitrakoot", value: "Chitrakoot" },
  { key: 786, label: "Amethi", value: "Amethi" },
  { key: 787, label: "Sambhal", value: "Sambhal" },
  { key: 788, label: "Shamli", value: "Shamli" },
  { key: 789, label: "Bijnor", value: "Bijnor" },
  { key: 790, label: "Bulandshahr", value: "Bulandshahr" },
  { key: 791, label: "Baghpat", value: "Baghpat" },
  { key: 792, label: "Hathras", value: "Hathras" },
  { key: 793, label: "Balrampur", value: "Balrampur" },
  { key: 794, label: "Kotdwar", value: "Kotdwar" },
  { key: 795, label: "Srinagar (Uttarakhand)", value: "Srinagar (Uttarakhand)" },
  { key: 796, label: "Mussoorie", value: "Mussoorie" },
  { key: 797, label: "Ranikhet", value: "Ranikhet" },
  { key: 798, label: "Khatima", value: "Khatima" },
  { key: 799, label: "Ramnagar", value: "Ramnagar" },
  { key: 800, label: "Pauri", value: "Pauri" },
  { key: 801, label: "Lansdowne", value: "Lansdowne" },
  { key: 802, label: "Contai", value: "Contai" },
  { key: 803, label: "Bolpur", value: "Bolpur" },
  { key: 804, label: "Jangipur", value: "Jangipur" },
  { key: 805, label: "Kandi", value: "Kandi" },
  { key: 806, label: "Rampurhat", value: "Rampurhat" },
  { key: 807, label: "Tamluk", value: "Tamluk" },
  { key: 808, label: "Diamond Harbour", value: "Diamond Harbour" },
  { key: 809, label: "Alipurduar", value: "Alipurduar" },
  { key: 810, label: "Islampur", value: "Islampur" },
  { key: 811, label: "New Chandigarh", value: "New Chandigarh" },
  { key: 812, label: "Rajouri", value: "Rajouri" },
  { key: 813, label: "Pulwama", value: "Pulwama" },
  { key: 814, label: "Kupwara", value: "Kupwara" },
  { key: 815, label: "Ganderbal", value: "Ganderbal" },
  { key: 816, label: "Kishtwar", value: "Kishtwar" },
  { key: 817, label: "Shopian", value: "Shopian" },
  { key: 818, label: "Bandipora", value: "Bandipora" },
  { key: 819, label: "Car Nicobar", value: "Car Nicobar" },
  { key: 820, label: "Diglipur", value: "Diglipur" },

  { key: 821, label: "24 Paraganas North", value: "24 Paraganas North" },
  { key: 822, label: "24 Paraganas South", value: "24 Paraganas South" },
  { key: 823, label: "Agar Malwa", value: "Agar Malwa" },
  { key: 824, label: "Ahmadabad", value: "Ahmadabad" },
  { key: 825, label: "Alirajpur", value: "Alirajpur" },
  { key: 826, label: "Alluri Sitharama Raju", value: "Alluri Sitharama Raju" },
  { key: 827, label: "Ambedkar Nagar", value: "Ambedkar Nagar" },
  { key: 828, label: "Anakapalli", value: "Anakapalli" },
  { key: 829, label: "Anjaw", value: "Anjaw" },
  { key: 830, label: "Annamayya", value: "Annamayya" },
  { key: 831, label: "Anugul", value: "Anugul" },
  { key: 832, label: "Anuppur", value: "Anuppur" },
  { key: 833, label: "Arvalli", value: "Arvalli" },
  { key: 834, label: "Arwal", value: "Arwal" },
  { key: 835, label: "Ashoknagar", value: "Ashoknagar" },
  { key: 836, label: "Bajali", value: "Bajali" },
  { key: 837, label: "Baksa", value: "Baksa" },
  { key: 838, label: "Baleshwar", value: "Baleshwar" },
  { key: 839, label: "Balod", value: "Balod" },
  { key: 840, label: "Baloda Bazar", value: "Baloda Bazar" },
  { key: 841, label: "Banas Kantha", value: "Banas Kantha" },
  { key: 842, label: "Banda", value: "Banda" },
  { key: 843, label: "Banka", value: "Banka" },
  { key: 844, label: "Bapatla", value: "Bapatla" },
  { key: 845, label: "Barabanki", value: "Barabanki" },
  { key: 846, label: "Barwani", value: "Barwani" },
  { key: 847, label: "Bastar", value: "Bastar" },
  { key: 848, label: "Bemetara", value: "Bemetara" },
  { key: 849, label: "Bengaluru Rural", value: "Bengaluru Rural" },
  { key: 850, label: "Bengaluru Urban", value: "Bengaluru Urban" },
  { key: 851, label: "Bhadohi", value: "Bhadohi" },
  { key: 852, label: "Bhadradri Kothagudem", value: "Bhadradri Kothagudem" },
  { key: 853, label: "Bhojpur", value: "Bhojpur" },
  { key: 854, label: "Birbhum", value: "Birbhum" },
  { key: 855, label: "Biswanath", value: "Biswanath" },
  { key: 856, label: "Boudh", value: "Boudh" },
  { key: 857, label: "Budgam", value: "Budgam" },
  { key: 858, label: "Buldhana", value: "Buldhana" },
  { key: 859, label: "Bundi", value: "Bundi" },
  { key: 860, label: "Cachar", value: "Cachar" },
  { key: 861, label: "Central", value: "Central" },
  { key: 862, label: "Chamarajanagara", value: "Chamarajanagara" },
  { key: 863, label: "Champawat", value: "Champawat" },
  { key: 864, label: "Chandauli", value: "Chandauli" },
  { key: 865, label: "Chandel", value: "Chandel" },
  { key: 866, label: "Chandrapur", value: "Chandrapur" },
  { key: 867, label: "Charaideo", value: "Charaideo" },
  { key: 868, label: "Charki Dadri", value: "Charki Dadri" },
  { key: 869, label: "Chatra", value: "Chatra" },
  { key: 870, label: "Chengalpattu", value: "Chengalpattu" },
  { key: 871, label: "Chhatarpur", value: "Chhatarpur" },
  { key: 872, label: "Chhotaudepur", value: "Chhotaudepur" },
  { key: 873, label: "Chikkaballapura", value: "Chikkaballapura" },
  { key: 874, label: "Chirang", value: "Chirang" },
  { key: 875, label: "Coochbehar", value: "Coochbehar" },
  { key: 876, label: "Dadra And Nagar Haveli", value: "Dadra And Nagar Haveli" },
  { key: 877, label: "Dakshina Kannada", value: "Dakshina Kannada" },
  { key: 878, label: "Dang", value: "Dang" },
  { key: 879, label: "Dantewada", value: "Dantewada" },
  { key: 880, label: "Darrang", value: "Darrang" },
  { key: 881, label: "Davangere", value: "Davangere" },
  { key: 882, label: "Deogarh", value: "Deogarh" },
  { key: 883, label: "Devbhumi Dwarka", value: "Devbhumi Dwarka" },
  { key: 884, label: "Dhalai", value: "Dhalai" },
  { key: 885, label: "Dhar", value: "Dhar" },
  { key: 886, label: "Dharmapuri", value: "Dharmapuri" },
  { key: 887, label: "Dibang Valley", value: "Dibang Valley" },
  { key: 888, label: "Dima Hasao", value: "Dima Hasao" },
  { key: 889, label: "Dinajpur Dakshin", value: "Dinajpur Dakshin" },
  { key: 890, label: "Dinajpur Uttar", value: "Dinajpur Uttar" },
  { key: 891, label: "Dindori", value: "Dindori" },
  { key: 892, label: "Doda", value: "Doda" },
  { key: 893, label: "Dohad", value: "Dohad" },
  { key: 894, label: "Dungarpur", value: "Dungarpur" },
  { key: 895, label: "East", value: "East" },
  { key: 896, label: "East District", value: "East District" },
  { key: 897, label: "East Garo Hills", value: "East Garo Hills" },
  { key: 898, label: "East Godavari", value: "East Godavari" },
  { key: 899, label: "East Jaintia Hills", value: "East Jaintia Hills" },
  { key: 900, label: "East Kameng", value: "East Kameng" },
  { key: 901, label: "East Khasi Hills", value: "East Khasi Hills" },
  { key: 902, label: "East Nimar", value: "East Nimar" },
  { key: 903, label: "East Siang", value: "East Siang" },
  { key: 904, label: "East Singhbum", value: "East Singhbum" },
  { key: 905, label: "Ernakulam", value: "Ernakulam" },
  { key: 906, label: "Etah", value: "Etah" },
  { key: 907, label: "Farrukhabad", value: "Farrukhabad" },
  { key: 908, label: "Fatehgarh Sahib", value: "Fatehgarh Sahib" },
  { key: 909, label: "Firozepur", value: "Firozepur" },
  { key: 910, label: "Gadchiroli", value: "Gadchiroli" },
  { key: 911, label: "Gajapati", value: "Gajapati" },
  { key: 912, label: "Ganganagar", value: "Ganganagar" },
  { key: 913, label: "Ganjam", value: "Ganjam" },
  { key: 914, label: "Garhwa", value: "Garhwa" },
  { key: 915, label: "Gariyaband", value: "Gariyaband" },
  { key: 916, label: "Gaurella Pendra Marwahi", value: "Gaurella Pendra Marwahi" },
  { key: 917, label: "Ghazipur", value: "Ghazipur" },
  { key: 918, label: "Gir Somnath", value: "Gir Somnath" },
  { key: 919, label: "Gomati", value: "Gomati" },
  { key: 920, label: "Gumla", value: "Gumla" },
  { key: 921, label: "Hanumakonda", value: "Hanumakonda" },
  { key: 922, label: "Harda", value: "Harda" },
  { key: 923, label: "Hnahthial", value: "Hnahthial" },
  { key: 924, label: "Hojai", value: "Hojai" },
  { key: 925, label: "Hooghly", value: "Hooghly" },
  { key: 926, label: "Imphal East", value: "Imphal East" },
  { key: 927, label: "Imphal West", value: "Imphal West" },
  { key: 928, label: "Jagatsinghapur", value: "Jagatsinghapur" },
  { key: 929, label: "Jagitial", value: "Jagitial" },
  { key: 930, label: "Jajapur", value: "Jajapur" },
  { key: 931, label: "Jalaun", value: "Jalaun" },
  { key: 932, label: "Jangoan", value: "Jangoan" },
  { key: 933, label: "Janjgir-champa", value: "Janjgir-champa" },
  { key: 934, label: "Jashpur", value: "Jashpur" },
  { key: 935, label: "Jayashankar Bhupalapally", value: "Jayashankar Bhupalapally" },
  { key: 936, label: "Jhabua", value: "Jhabua" },
  { key: 937, label: "Jhajjar", value: "Jhajjar" },
  { key: 938, label: "Jhargram", value: "Jhargram" },
  { key: 939, label: "Jiribam", value: "Jiribam" },
  { key: 940, label: "Jogulamba Gadwal", value: "Jogulamba Gadwal" },
  { key: 941, label: "Kabirdham", value: "Kabirdham" },
  { key: 942, label: "Kachchh", value: "Kachchh" },
  { key: 943, label: "Kaimur (bhabua)", value: "Kaimur (bhabua)" },
  { key: 944, label: "Kalimpong", value: "Kalimpong" },
  { key: 945, label: "Kallakurichi", value: "Kallakurichi" },
  { key: 946, label: "Kamjong", value: "Kamjong" },
  { key: 947, label: "Kamle", value: "Kamle" },
  { key: 948, label: "Kamrup", value: "Kamrup" },
  { key: 949, label: "Kamrup Metro", value: "Kamrup Metro" },
  { key: 950, label: "Kandhamal", value: "Kandhamal" },
  { key: 951, label: "Kangpokpi", value: "Kangpokpi" },
  { key: 952, label: "Kanpur Dehat", value: "Kanpur Dehat" },
  { key: 953, label: "Kanpur Nagar", value: "Kanpur Nagar" },
  { key: 954, label: "Karauli", value: "Karauli" },
  { key: 955, label: "Karbi Anglong", value: "Karbi Anglong" },
  { key: 956, label: "Kaushambi", value: "Kaushambi" },
  { key: 957, label: "Kendujhar", value: "Kendujhar" },
  { key: 958, label: "Khagaria", value: "Khagaria" },
  { key: 959, label: "Khargone", value: "Khargone" },
  { key: 960, label: "Khawzawl", value: "Khawzawl" },
  { key: 961, label: "Kheda", value: "Kheda" },
  { key: 962, label: "Kheri", value: "Kheri" },
  { key: 963, label: "Khordha", value: "Khordha" },
  { key: 964, label: "Kiphire", value: "Kiphire" },
  { key: 965, label: "Kodagu", value: "Kodagu" },
  { key: 966, label: "Koderma", value: "Koderma" },
  { key: 967, label: "Kokrajhar", value: "Kokrajhar" },
  { key: 968, label: "Konaseema", value: "Konaseema" },
  { key: 969, label: "Korea", value: "Korea" },
  { key: 970, label: "Kra Daadi", value: "Kra Daadi" },
  { key: 971, label: "Krishna", value: "Krishna" },
  { key: 972, label: "Krishnagiri", value: "Krishnagiri" },
  { key: 973, label: "Kulgam", value: "Kulgam" },
  { key: 974, label: "Kumuram Bheem Asifabad", value: "Kumuram Bheem Asifabad" },
  { key: 975, label: "Kurung Kumey", value: "Kurung Kumey" },
  { key: 976, label: "Kushi Nagar", value: "Kushi Nagar" },
  { key: 977, label: "Lahul And Spiti", value: "Lahul And Spiti" },
  { key: 978, label: "Lakhisarai", value: "Lakhisarai" },
  { key: 979, label: "Lakshadweep District", value: "Lakshadweep District" },
  { key: 980, label: "Lalitpur", value: "Lalitpur" },
  { key: 981, label: "Latehar", value: "Latehar" },
  { key: 982, label: "Leh Ladakh", value: "Leh Ladakh" },
  { key: 983, label: "Leparada", value: "Leparada" },
  { key: 984, label: "Lohit", value: "Lohit" },
  { key: 985, label: "Longding", value: "Longding" },
  { key: 986, label: "Longleng", value: "Longleng" },
  { key: 987, label: "Lower Dibang Valley", value: "Lower Dibang Valley" },
  { key: 988, label: "Lower Siang", value: "Lower Siang" },
  { key: 989, label: "Lower Subansiri", value: "Lower Subansiri" },
  { key: 990, label: "Madhepura", value: "Madhepura" },
  { key: 991, label: "Mahabubnagar", value: "Mahabubnagar" },
  { key: 992, label: "Maharajganj", value: "Maharajganj" },
  { key: 993, label: "Mahendragarh", value: "Mahendragarh" },
  { key: 994, label: "Mahesana", value: "Mahesana" },
  { key: 995, label: "Mahisagar", value: "Mahisagar" },
  { key: 996, label: "Mahoba", value: "Mahoba" },
  { key: 997, label: "Majuli", value: "Majuli" },
  { key: 998, label: "Maldah", value: "Maldah" },
  { key: 999, label: "Malkangiri", value: "Malkangiri" },
  { key: 1000, label: "Mamit", value: "Mamit" },
  { key: 1001, label: "Marigaon", value: "Marigaon" },
  { key: 1002, label: "Mayurbhanj", value: "Mayurbhanj" },
  { key: 1003, label: "Medchal Malkajgiri", value: "Medchal Malkajgiri" },
  { key: 1004, label: "Medinipur East", value: "Medinipur East" },
  { key: 1005, label: "Medinipur West", value: "Medinipur West" },
  { key: 1006, label: "Mulugu", value: "Mulugu" },
  { key: 1007, label: "Mumbai Suburban", value: "Mumbai Suburban" },
  { key: 1008, label: "Mungeli", value: "Mungeli" },
  { key: 1009, label: "Murshidabad", value: "Murshidabad" },
  { key: 1010, label: "Nadia", value: "Nadia" },
  { key: 1011, label: "Nalanda", value: "Nalanda" },
  { key: 1012, label: "Nalbari", value: "Nalbari" },
  { key: 1013, label: "Nandurbar", value: "Nandurbar" },
  { key: 1014, label: "Narayanpet", value: "Narayanpet" },
  { key: 1015, label: "Narayanpur", value: "Narayanpur" },
  { key: 1016, label: "Narmada", value: "Narmada" },
  { key: 1017, label: "Nayagarh", value: "Nayagarh" },
  { key: 1018, label: "Nicobars", value: "Nicobars" },
  { key: 1019, label: "Niwari", value: "Niwari" },
  { key: 1020, label: "Noklak", value: "Noklak" },
  { key: 1021, label: "Noney", value: "Noney" },
  { key: 1022, label: "North", value: "North" },
  { key: 1023, label: "North And Middle Andaman", value: "North And Middle Andaman" },
  { key: 1024, label: "North District", value: "North District" },
  { key: 1025, label: "North East", value: "North East" },
  { key: 1026, label: "North Garo Hills", value: "North Garo Hills" },
  { key: 1027, label: "North Goa", value: "North Goa" },
  { key: 1028, label: "North Tripura", value: "North Tripura" },
  { key: 1029, label: "North West", value: "North West" },
  { key: 1030, label: "Ntr", value: "Ntr" },
  { key: 1031, label: "Nuh", value: "Nuh" },
  { key: 1032, label: "Pakke Kessang", value: "Pakke Kessang" },
  { key: 1033, label: "Palamu", value: "Palamu" },
  { key: 1034, label: "Palghar", value: "Palghar" },
  { key: 1035, label: "Palnadu", value: "Palnadu" },
  { key: 1036, label: "Panch Mahals", value: "Panch Mahals" },
  { key: 1037, label: "Panna", value: "Panna" },
  { key: 1038, label: "Papum Pare", value: "Papum Pare" },
  { key: 1039, label: "Parvathipuram Manyam", value: "Parvathipuram Manyam" },
  { key: 1040, label: "Paschim Bardhaman", value: "Paschim Bardhaman" },
  { key: 1041, label: "Pashchim Champaran", value: "Pashchim Champaran" },
  { key: 1042, label: "Pauri Garhwal", value: "Pauri Garhwal" },
  { key: 1043, label: "Peddapalli", value: "Peddapalli" },
  { key: 1044, label: "Peren", value: "Peren" },
  { key: 1045, label: "Pherzawl", value: "Pherzawl" },
  { key: 1046, label: "Pondicherry", value: "Pondicherry" },
  { key: 1047, label: "Poonch", value: "Poonch" },
  { key: 1048, label: "Prakasam", value: "Prakasam" },
  { key: 1049, label: "Purba Bardhaman", value: "Purba Bardhaman" },
  { key: 1050, label: "Purbi Champaran", value: "Purbi Champaran" },
  { key: 1051, label: "Rae Bareli", value: "Rae Bareli" },
  { key: 1052, label: "Raigad", value: "Raigad" },
  { key: 1053, label: "Raisen", value: "Raisen" },
  { key: 1054, label: "Rajanna Sircilla", value: "Rajanna Sircilla" },
  { key: 1055, label: "Rajgarh", value: "Rajgarh" },
  { key: 1056, label: "Rajsamand", value: "Rajsamand" },
  { key: 1057, label: "Ramanathapuram", value: "Ramanathapuram" },
  { key: 1058, label: "Ramban", value: "Ramban" },
  { key: 1059, label: "Ranga Reddy", value: "Ranga Reddy" },
  { key: 1060, label: "Reasi", value: "Reasi" },
  { key: 1061, label: "Ri Bhoi", value: "Ri Bhoi" },
  { key: 1062, label: "Rohtas", value: "Rohtas" },
  { key: 1063, label: "Rudra Prayag", value: "Rudra Prayag" },
  { key: 1064, label: "S.A.S Nagar", value: "S.A.S Nagar" },
  { key: 1065, label: "Sabar Kantha", value: "Sabar Kantha" },
  { key: 1066, label: "Sahebganj", value: "Sahebganj" },
  { key: 1067, label: "Saiha", value: "Saiha" },
  { key: 1068, label: "Saitual", value: "Saitual" },
  { key: 1069, label: "Samba", value: "Samba" },
  { key: 1070, label: "Sant Kabeer Nagar", value: "Sant Kabeer Nagar" },
  { key: 1071, label: "Saraikela Kharsawan", value: "Saraikela Kharsawan" },
  { key: 1072, label: "Saran", value: "Saran" },
  { key: 1073, label: "Sepahijala", value: "Sepahijala" },
  { key: 1074, label: "Shahdara", value: "Shahdara" },
  { key: 1075, label: "Shahid Bhagat Singh Nagar", value: "Shahid Bhagat Singh Nagar" },
  { key: 1076, label: "Sheikhpura", value: "Sheikhpura" },
  { key: 1077, label: "Sheohar", value: "Sheohar" },
  { key: 1078, label: "Sheopur", value: "Sheopur" },
  { key: 1079, label: "Shi Yomi", value: "Shi Yomi" },
  { key: 1080, label: "Shravasti", value: "Shravasti" },
  { key: 1081, label: "Siang", value: "Siang" },
  { key: 1082, label: "Siddharth Nagar", value: "Siddharth Nagar" },
  { key: 1083, label: "Sidhi", value: "Sidhi" },
  { key: 1084, label: "Sirmaur", value: "Sirmaur" },
  { key: 1085, label: "Sitamarhi", value: "Sitamarhi" },
  { key: 1086, label: "Sivaganga", value: "Sivaganga" },
  { key: 1087, label: "Sonepur", value: "Sonepur" },
  { key: 1088, label: "Sonitpur", value: "Sonitpur" },
  { key: 1089, label: "Soreng", value: "Soreng" },
  { key: 1090, label: "South", value: "South" },
  { key: 1091, label: "South Andamans", value: "South Andamans" },
  { key: 1092, label: "South District", value: "South District" },
  { key: 1093, label: "South East", value: "South East" },
  { key: 1094, label: "South Garo Hills", value: "South Garo Hills" },
  { key: 1095, label: "South Goa", value: "South Goa" },
  { key: 1096, label: "South Salmara Mancachar", value: "South Salmara Mancachar" },
  { key: 1097, label: "South Tripura", value: "South Tripura" },
  { key: 1098, label: "South West", value: "South West" },
  { key: 1099, label: "South West Garo Hills", value: "South West Garo Hills" },
  { key: 1100, label: "South West Khasi Hills", value: "South West Khasi Hills" },
  { key: 1101, label: "Spsr Nellore", value: "Spsr Nellore" },
  { key: 1102, label: "Sri Muktsar Sahib", value: "Sri Muktsar Sahib" },
  { key: 1103, label: "Sri Sathya Sai", value: "Sri Sathya Sai" },
  { key: 1104, label: "Sukma", value: "Sukma" },
  { key: 1105, label: "Surajpur", value: "Surajpur" },
  { key: 1106, label: "Surguja", value: "Surguja" },
  { key: 1107, label: "Tamenglong", value: "Tamenglong" },
  { key: 1108, label: "Tapi", value: "Tapi" },
  { key: 1109, label: "Tehri Garhwal", value: "Tehri Garhwal" },
  { key: 1110, label: "Tengnoupal", value: "Tengnoupal" },
  { key: 1111, label: "The Nilgiris", value: "The Nilgiris" },
  { key: 1112, label: "Theni", value: "Theni" },
  { key: 1113, label: "Thiruvallur", value: "Thiruvallur" },
  { key: 1114, label: "Thiruvarur", value: "Thiruvarur" },
  { key: 1115, label: "Tirap", value: "Tirap" },
  { key: 1116, label: "Tirupathur", value: "Tirupathur" },
  { key: 1117, label: "Tiruvannamalai", value: "Tiruvannamalai" },
  { key: 1118, label: "Tuticorin", value: "Tuticorin" },
  { key: 1119, label: "Udam Singh Nagar", value: "Udam Singh Nagar" },
  { key: 1120, label: "Ukhrul", value: "Ukhrul" },
  { key: 1121, label: "Umaria", value: "Umaria" },
  { key: 1122, label: "Unakoti", value: "Unakoti" },
  { key: 1123, label: "Upper Siang", value: "Upper Siang" },
  { key: 1124, label: "Upper Subansiri", value: "Upper Subansiri" },
  { key: 1125, label: "Uttar Kashi", value: "Uttar Kashi" },
  { key: 1126, label: "Vaishali", value: "Vaishali" },
  { key: 1127, label: "Vijaynagar", value: "Vijaynagar" },
  { key: 1128, label: "Villupuram", value: "Villupuram" },
  { key: 1129, label: "Visakhapatanam", value: "Visakhapatanam" },
  { key: 1130, label: "Wayanad", value: "Wayanad" },
  { key: 1131, label: "West", value: "West" },
  { key: 1132, label: "West District", value: "West District" },
  { key: 1133, label: "West Garo Hills", value: "West Garo Hills" },
  { key: 1134, label: "West Godavari", value: "West Godavari" },
  { key: 1135, label: "West Jaintia Hills", value: "West Jaintia Hills" },
  { key: 1136, label: "West Kameng", value: "West Kameng" },
  { key: 1137, label: "West Karbi Anglong", value: "West Karbi Anglong" },
  { key: 1138, label: "West Khasi Hills", value: "West Khasi Hills" },
  { key: 1139, label: "West Siang", value: "West Siang" },
  { key: 1140, label: "West Singhbhum", value: "West Singhbhum" },
  { key: 1141, label: "West Tripura", value: "West Tripura" },
  { key: 1142, label: "Y.S.R.", value: "Y.S.R." },
  { key: 1143, label: "Yadadri Bhuvanagiri", value: "Yadadri Bhuvanagiri" },
  { key: 1144, label: "Zunheboto", value: "Zunheboto" },
];

// export const stateOptions = [
//   {
//     key: 1,
//     label: "Andaman and Nicobar Islands",
//     value: "Andaman and Nicobar Islands",
//   },
//   {key: 2, label: "Andhra Pradesh", value: "Andhra Pradesh"},
//   {key: 3, label: "Arunachal Pradesh", value: "Arunachal Pradesh"},
//   {key: 4, label: "Assam", value: "Assam"},
//   {key: 5, label: "Bihar", value: "Bihar"},
//   {key: 6, label: "Chandigarh", value: "Chandigarh"},
//   {key: 7, label: "Chhattisgarh", value: "Chhattisgarh"},
//   {
//     key: 8,
//     label: "Dadra and Nagar Haveli and Daman and Diu",
//     value: "Dadra and Nagar Haveli and Daman and Diu",
//   },
//   {key: 9, label: "Delhi", value: "Delhi"},
//   {key: 10, label: "Goa", value: "Goa"},
//   {key: 11, label: "Gujarat", value: "Gujarat"},
//   {key: 12, label: "Haryana", value: "Haryana"},
//   {key: 13, label: "Himachal Pradesh", value: "Himachal Pradesh"},
//   {key: 14, label: "Hyderabad", value: "Hyderabad"},
//   {key: 15, label: "Jammu and Kashmir", value: "Jammu and Kashmir"},
//   {key: 16, label: "Jharkhand", value: "Jharkhand"},
//   {key: 17, label: "Karnataka", value: "Karnataka"},
//   {key: 18, label: "Kerala", value: "Kerala"},
//   {key: 19, label: "Ladakh", value: "Ladakh"},
//   {key: 20, label: "Lakshadweep", value: "Lakshadweep"},
//   {key: 21, label: "Madhya Pradesh", value: "Madhya Pradesh"},
//   {key: 22, label: "Maharashtra", value: "Maharashtra"},
//   {key: 23, label: "Manipur", value: "Manipur"},
//   {key: 24, label: "Meghalaya", value: "Meghalaya"},
//   {key: 25, label: "Mizoram", value: "Mizoram"},
//   {key: 26, label: "Nagaland", value: "Nagaland"},
//   {key: 27, label: "Odisha", value: "Odisha"},
//   {key: 28, label: "Puducherry", value: "Puducherry"},
//   {key: 29, label: "Punjab", value: "Punjab"},
//   {key: 30, label: "Rajasthan", value: "Rajasthan"},
//   {key: 31, label: "Sikkim", value: "Sikkim"},
//   {key: 32, label: "Tamil Nadu", value: "Tamil Nadu"},
//   {key: 33, label: "Telangana", value: "Telangana"},
//   {key: 34, label: "Tripura", value: "Tripura"},
//   {key: 35, label: "Uttar Pradesh", value: "Uttar Pradesh"},
//   {key: 36, label: "Uttarakhand", value: "Uttarakhand"},
//   {key: 37, label: "West Bengal", value: "West Bengal"},
// ];

export const stateOptions = [
  {
    key: 1,
    label: "Jammu and Kashmir",
    value: "Jammu and Kashmir",
  },
  {
    key: 2,
    label: "Himachal Pradesh",
    value: "Himachal Pradesh",
  },
  {
    key: 3,
    label: "Punjab",
    value: "Punjab",
  },
  {
    key: 4,
    label: "Chandigarh",
    value: "Chandigarh",
  },
  {
    key: 5,
    label: "Uttarakhand",
    value: "Uttarakhand",
  },
  {
    key: 6,
    label: "Haryana",
    value: "Haryana",
  },
  {
    key: 7,
    label: "Delhi",
    value: "Delhi",
  },
  {
    key: 8,
    label: "Rajasthan",
    value: "Rajasthan",
  },
  {
    key: 9,
    label: "Uttar Pradesh",
    value: "Uttar Pradesh",
  },
  {
    key: 10,
    label: "Bihar",
    value: "Bihar",
  },
  {
    key: 11,
    label: "Sikkim",
    value: "Sikkim",
  },
  {
    key: 12,
    label: "Arunachal Pradesh",
    value: "Arunachal Pradesh",
  },
  {
    key: 13,
    label: "Nagaland",
    value: "Nagaland",
  },
  {
    key: 14,
    label: "Manipur",
    value: "Manipur",
  },
  {
    key: 15,
    label: "Mizoram",
    value: "Mizoram",
  },
  {
    key: 16,
    label: "Tripura",
    value: "Tripura",
  },
  {
    key: 17,
    label: "Meghalaya",
    value: "Meghalaya",
  },
  {
    key: 18,
    label: "Assam",
    value: "Assam",
  },
  {
    key: 19,
    label: "West Bengal",
    value: "West Bengal",
  },
  {
    key: 20,
    label: "Jharkhand",
    value: "Jharkhand",
  },
  {
    key: 21,
    label: "Odisha",
    value: "Odisha",
  },
  {
    key: 22,
    label: "Chhattisgarh",
    value: "Chhattisgarh",
  },
  {
    key: 23,
    label: "Madhya Pradesh",
    value: "Madhya Pradesh",
  },
  {
    key: 24,
    label: "Gujarat",
    value: "Gujarat",
  },
  {
    key: 25,
    label: "Daman and Diu",
    value: "Daman and Diu",
  },
  {
    key: 26,
    label: "Dadra and Nagar Haveli",
    value: "Dadra and Nagar Haveli",
  },
  {
    key: 27,
    label: "Maharashtra",
    value: "Maharashtra",
  },
  {
    key: 28,
    label: "Andhra Pradesh", // Removed from original list, but added back in
    value: "Andhra Pradesh",
  },
  {
    key: 29,
    label: "Karnataka",
    value: "Karnataka",
  },
  {
    key: 30,
    label: "Goa",
    value: "Goa",
  },
  {
    key: 31,
    label: "Lakshadweep",
    value: "Lakshadweep",
  },
  {
    key: 32,
    label: "Kerala",
    value: "Kerala",
  },
  {
    key: 33,
    label: "Tamil Nadu",
    value: "Tamil Nadu",
  },
  {
    key: 34,
    label: "Puducherry",
    value: "Puducherry",
  },
  {
    key: 35,
    label: "Andaman and Nicobar",
    value: "Andaman and Nicobar",
  },
  {
    key: 36,
    label: "Telangana",
    value: "Telangana",
  },
//   {
//     key: 37,
//     label: "Andhra Pradesh",
//     value: "Andhra Pradesh",
//  },
  {
    key: 38,
    label: "Ladakh",
    value: "Ladakh",
  },
];

export const dropDownData = {
  primary_material_type: [
    {key: "bamboo", label: "Bamboo", value: "Bamboo"},
    {key: "ceramic", label: "Ceramic", value: "Ceramic"},
    {key: "crystal", label: "Crystal", value: "Crystal"},
    {key: "faux_wood", label: "Faux Wood", value: "Faux Wood"},
    {key: "glass", label: "Glass", value: "Glass"},
    {key: "metal", label: "Metal", value: "Metal"},
    {key: "plastic", label: "Plastic", value: "Plastic"},
    {key: "resin", label: "Resin", value: "Resin"},
    {key: "wood", label: "Wood", value: "Wood"},
    {key: "abs", label: "ABS", value: "ABS"},
    {key: "aluminum", label: "Aluminum", value: "Aluminum"},
    {key: "aluminum_oxide", label: "Aluminum Oxide", value: "Aluminum Oxide"},
    {key: "antimony", label: "Antimony", value: "Antimony"},
    {key: "baking_soda", label: "Baking Soda", value: "Baking Soda"},
    {key: "bismuth", label: "Bismuth", value: "Bismuth"},
    {key: "black_oxide", label: "Black Oxide", value: "Black Oxide"},
    {key: "brass", label: "Brass", value: "Brass"},
    {key: "bronze", label: "Bronze", value: "Bronze"},
    {key: "butyl", label: "Butyl", value: "Butyl"},
    {key: "cpvc", label: "CPVC", value: "CPVC"},
    {key: "cadmium", label: "Cadmium", value: "Cadmium"},
    {key: "calcite", label: "Calcite", value: "Calcite"},
    {key: "carbide", label: "Carbide", value: "Carbide"},
    {key: "carbon_steel", label: "Carbon Steel", value: "Carbon Steel"},
    {
      key: "ceramic_iron_oxide",
      label: "Ceramic Iron Oxide",
      value: "Ceramic Iron Oxide",
    },
    {key: "cermet", label: "Cermet", value: "Cermet"},
    {key: "cerro_alloys", label: "Cerro Alloys", value: "Cerro Alloys"},
    {key: "chloroprene", label: "Chloroprene", value: "Chloroprene"},
    {
      key: "chlorosulfonated_polyethylene",
      label: "Chlorosulfonated Polyethylene (CSM)",
      value: "Chlorosulfonated Polyethylene (CSM)",
    },
    {key: "chromium", label: "Chromium", value: "Chromium"},
    {key: "chromium_oxide", label: "Chromium Oxide", value: "Chromium Oxide"},
    {key: "cobalt", label: "Cobalt", value: "Cobalt"},
    {key: "cobalt_steel", label: "Cobalt Steel", value: "Cobalt Steel"},
    {
      key: "cold_rolled_steel",
      label: "Cold Rolled Steel",
      value: "Cold Rolled Steel",
    },
    {key: "copper", label: "Copper", value: "Copper"},
    {key: "cordierite", label: "Cordierite", value: "Cordierite"},
    {key: "corn_cob", label: "Corn Cob", value: "Corn Cob"},
    {key: "corundum", label: "Corundum", value: "Corundum"},
    {key: "crocus", label: "Crocus", value: "Crocus"},
    {key: "crystal_1", label: "Crystal", value: "Crystal"},
    {
      key: "cubic_boron_nitride",
      label: "Cubic Boron Nitride",
      value: "Cubic Boron Nitride",
    },
    {
      key: "cubic_boron_nitride_cbn",
      label: "Cubic Boron Nitride (CBN)",
      value: "Cubic Boron Nitride (CBN)",
    },
    {key: "diamond", label: "Diamond", value: "Diamond"},
    {key: "elastomers", label: "Elastomers", value: "Elastomers"},
    {key: "emery", label: "Emery", value: "Emery"},
    {key: "fabric", label: "Fabric", value: "Fabric"},
    {key: "felt", label: "Felt", value: "Felt"},
    {key: "fiberglass", label: "Fiberglass", value: "Fiberglass"},
    {key: "fibralon", label: "Fibralon", value: "Fibralon"},
    {key: "foam", label: "Foam", value: "Foam"},
    {key: "forged", label: "Forged", value: "Forged"},
    {
      key: "galvanized_steel",
      label: "Galvanized Steel",
      value: "Galvanized Steel",
    },
    {key: "garnet", label: "Garnet", value: "Garnet"},
    {
      key: "glass_aluminum_oxide",
      label: "Glass-Aluminum Oxide",
      value: "Glass-Aluminum Oxide",
    },
    {key: "gold", label: "Gold", value: "Gold"},
    {key: "gold_ferroud", label: "Gold Ferroud", value: "Gold Ferroud"},
    {key: "graphite", label: "Graphite", value: "Graphite"},
    {key: "gum_rubber", label: "Gum Rubber", value: "Gum Rubber"},
    {key: "hastelloy", label: "Hastelloy", value: "Hastelloy"},
    {key: "heat_treated", label: "Heat-Treated", value: "Heat-Treated"},
    {
      key: "high_density_polyethylene",
      label: "High Density Polyethylene (HDPE)",
      value: "High Density Polyethylene (HDPE)",
    },
    {
      key: "high_speed_steel",
      label: "High Speed Steel (HSS)",
      value: "High Speed Steel (HSS)",
    },
    {
      key: "hot_rolled_steel",
      label: "Hot Rolled Steel",
      value: "Hot Rolled Steel",
    },
    {key: "hydex", label: "Hydex", value: "Hydex"},
    {
      key: "hydrogenated_nitrile_butadiene_rubber",
      label: "Hydrogenated Nitrile Butadiene Rubber (HNBR)",
      value: "Hydrogenated Nitrile Butadiene Rubber (HNBR)",
    },
    {key: "inconel", label: "Inconel", value: "Inconel"},
    {key: "iron", label: "Iron", value: "Iron"},
    {
      key: "iron_cast_iron",
      label: "Iron & Cast Iron",
      value: "Iron & Cast Iron",
    },
    {key: "iron_oxide", label: "Iron Oxide", value: "Iron Oxide"},
    {key: "kalrez", label: "Kalrez", value: "Kalrez"},
    {key: "kevlar", label: "Kevlar", value: "Kevlar"},
    {key: "kraft_paper", label: "Kraft Paper", value: "Kraft Paper"},
    {key: "latex", label: "Latex", value: "Latex"},
    {key: "lead", label: "Lead", value: "Lead"},
    {key: "leather", label: "Leather", value: "Leather"},
    {key: "lexon", label: "Lexon", value: "Lexon"},
    {
      key: "liquid_silicone_rubber",
      label: "Liquid Silicone Rubber",
      value: "Liquid Silicone Rubber",
    },
    {
      key: "low_density_polyethylene",
      label: "Low Density Polyethylene (LDPE)",
      value: "Low Density Polyethylene (LDPE)",
    },
    {key: "magnesium", label: "Magnesium", value: "Magnesium"},
    {
      key: "manganese_steel",
      label: "Manganese Steel",
      value: "Manganese Steel",
    },
    {key: "maraging_steel", label: "Maraging Steel", value: "Maraging Steel"},
    {key: "marble", label: "Marble", value: "Marble"},
    {key: "metal_1", label: "Metal", value: "Metal"},
    {key: "molded_epoxy", label: "Molded Epoxy", value: "Molded Epoxy"},
    {
      key: "molybdenum_steel",
      label: "Molybdenum Steel",
      value: "Molybdenum Steel",
    },
    {key: "mullite", label: "Mullite", value: "Mullite"},
    {key: "natural_rubber", label: "Natural Rubber", value: "Natural Rubber"},
    {key: "neoprene", label: "Neoprene", value: "Neoprene"},
    {key: "nickel", label: "Nickel", value: "Nickel"},
    {key: "nitinol", label: "Nitinol", value: "Nitinol"},
    {key: "nitrile_rubber", label: "Nitrile Rubber", value: "Nitrile Rubber"},
    {key: "novaculite", label: "Novaculite", value: "Novaculite"},
    {key: "nylon", label: "Nylon", value: "Nylon"},
    {key: "oak", label: "Oak", value: "Oak"},
    {key: "petg", label: "PETG", value: "PETG"},
    {key: "pex", label: "PEX", value: "PEX"},
    {key: "pvc", label: "PVC", value: "PVC"},
    {key: "paper", label: "Paper", value: "Paper"},
    {key: "pebax", label: "Pebax", value: "Pebax"},
    {
      key: "perfluoralkoxy",
      label: "Perfluoralkoxy (PFA)",
      value: "Perfluoralkoxy (PFA)",
    },
    {
      key: "perfluoroelastomer",
      label: "Perfluoroelastomer",
      value: "Perfluoroelastomer",
    },
    {key: "pewter", label: "Pewter", value: "Pewter"},
    {key: "phenolic", label: "Phenolic", value: "Phenolic"},
    {key: "pine", label: "Pine", value: "Pine"},
    {key: "plastic_1", label: "Plastic", value: "Plastic"},
    {key: "platinum", label: "Platinum", value: "Platinum"},
    {key: "polyacrylate", label: "Polyacrylate", value: "Polyacrylate"},
    {
      key: "polyamide_imide",
      label: "Polyamide Imide",
      value: "Polyamide Imide",
    },
    {
      key: "polybutylene_terephthalate",
      label: "Polybutylene Terephtalate (PBT)",
      value: "Polybutylene Terephtalate (PBT)",
    },
    {key: "polycarbonate", label: "Polycarbonate", value: "Polycarbonate"},
    {
      key: "polychloroprene",
      label: "Polychloroprene",
      value: "Polychloroprene",
    },
    {
      key: "polycrystalline_diamond",
      label: "Polycrystalline Diamond (PCD)",
      value: "Polycrystalline Diamond (PCD)",
    },
    {key: "polyester", label: "Polyester", value: "Polyester"},
    {
      key: "peek",
      label: "Polyetheretherketone (PEEK)",
      value: "Polyetheretherketone (PEEK)",
    },
    {key: "polyetherimide", label: "Polyetherimide", value: "Polyetherimide"},
    {
      key: "polyethersulfone",
      label: "Polyethersulfone",
      value: "Polyethersulfone",
    },
    {key: "polyethylene", label: "Polyethylene", value: "Polyethylene"},
    {key: "polyimide", label: "Polyimide", value: "Polyimide"},
    {key: "polymer", label: "Polymer", value: "Polymer"},
    {
      key: "polymethylpentane",
      label: "Polymethylpentane",
      value: "Polymethylpentane",
    },
    {key: "polyolefin", label: "Polyolefin", value: "Polyolefin"},
    {
      key: "delrin",
      label: "Polyoxymethylene (Delrin)",
      value: "Polyoxymethylene (Delrin)",
    },
    {
      key: "noryl_en265",
      label: "Polyphenylene Ether (NORYL EN-265)",
      value: "Polyphenylene Ether (NORYL EN-265)",
    },
    {
      key: "polyphenylene_oxide",
      label: "Polyphenylene Oxide",
      value: "Polyphenylene Oxide",
    },
    {
      key: "pps",
      label: "Polyphenylene Sulfide (PPS)",
      value: "Polyphenylene Sulfide (PPS)",
    },
    {key: "polypropylene", label: "Polypropylene", value: "Polypropylene"},
    {key: "polystyrene", label: "Polystyrene", value: "Polystyrene"},
    {key: "polysulfone", label: "Polysulfone", value: "Polysulfone"},
    {
      key: "fluorosint_500_ptfe",
      label: "Polytetrafluoroethylene (FLUOROSINT 500 PTFE)",
      value: "Polytetrafluoroethylene (FLUOROSINT 500 PTFE)",
    },
    {
      key: "ptfe",
      label: "Polytetrafluoroethylene (PTFE)",
      value: "Polytetrafluoroethylene (PTFE)",
    },
    {key: "polyurethane", label: "Polyurethane", value: "Polyurethane"},
    {
      key: "pva",
      label: "Polyvinyl Acetate (PVA)",
      value: "Polyvinyl Acetate (PVA)",
    },
    {
      key: "pvc_type_i",
      label: "Polyvinyl Chloride Type I",
      value: "Polyvinyl Chloride Type I",
    },
    {
      key: "pvc_type_ii",
      label: "Polyvinyl Chloride Type II",
      value: "Polyvinyl Chloride Type II",
    },
    {
      key: "pvdf",
      label: "Polyvinylidene Fluoride (PVDF)",
      value: "Polyvinylidene Fluoride (PVDF)",
    },
    {key: "porcelain", label: "Porcelain", value: "Porcelain"},
    {
      key: "powdered_metal_cobalt_steel",
      label: "Powdered Metal Cobalt Steel",
      value: "Powdered Metal Cobalt Steel",
    },
    {
      key: "powdered_metal_steel",
      label: "Powdered Metal Steel",
      value: "Powdered Metal Steel",
    },
    {key: "pumice", label: "Pumice", value: "Pumice"},
    {key: "quartz", label: "Quartz", value: "Quartz"},
    {key: "resin", label: "Resin", value: "Resin"},
    {key: "rhodium", label: "Rhodium", value: "Rhodium"},
    {key: "rosewood", label: "Rosewood", value: "Rosewood"},
    {key: "rubber", label: "Rubber", value: "Rubber"},
    {key: "ruby", label: "Ruby", value: "Ruby"},
    {key: "rulon_ar", label: "Rulon AR", value: "Rulon AR"},
    {key: "rulon_j", label: "Rulon J", value: "Rulon J"},
    {key: "rulon_lr", label: "Rulon LR", value: "Rulon LR"},
    {key: "sand", label: "Sand", value: "Sand"},
    {
      key: "silicon_carbide",
      label: "Silicon Carbide",
      value: "Silicon Carbide",
    },
    {
      key: "silicon_carbide_aluminum_oxide",
      label: "Silicon Carbide-Aluminum Oxide",
      value: "Silicon Carbide-Aluminum Oxide",
    },
    {
      key: "silicon_dioxide",
      label: "Silicon Dioxide (Silica)",
      value: "Silicon Dioxide (Silica)",
    },
    {
      key: "silicon_manganese_steel",
      label: "Silicon Manganese Steel",
      value: "Silicon Manganese Steel",
    },
    {
      key: "silicone_rubber",
      label: "Silicone Rubber",
      value: "Silicone Rubber",
    },
    {key: "sillimanite", label: "Sillimanite", value: "Sillimanite"},
    {key: "silver", label: "Silver", value: "Silver"},
    {key: "simriz", label: "Simriz", value: "Simriz"},
    {key: "spring_steel", label: "Spring Steel", value: "Spring Steel"},
    {
      key: "stainless_steel",
      label: "Stainless Steel",
      value: "Stainless Steel",
    },
    {key: "steatite", label: "Steatite", value: "Steatite"},
    {key: "steel", label: "Steel", value: "Steel"},
    {key: "steel_shot", label: "Steel Shot", value: "Steel Shot"},
    {key: "stone", label: "Stone", value: "Stone"},
    {
      key: "styrene_butadiene_rubber",
      label: "Styrene-butadiene Rubber",
      value: "Styrene-butadiene Rubber",
    },
    {
      key: "pmma",
      label: "Synthetic Polymer (PMMA)",
      value: "Synthetic Polymer (PMMA)",
    },
    {key: "synthetic_ruby", label: "Synthetic Ruby", value: "Synthetic Ruby"},
    {
      key: "synthetic_sapphire",
      label: "Synthetic Sapphire",
      value: "Synthetic Sapphire",
    },
    {key: "talc", label: "Talc", value: "Talc"},
    {key: "teak", label: "Teak", value: "Teak"},
    {
      key: "tetrafluoroethylene_hexafluoropropylene_vinylidene_fluoride",
      label: "Tetrafluoroethylene Hexafluoropropylene Vinylidene Fluoride",
      value: "Tetrafluoroethylene Hexafluoropropylene Vinylidene Fluoride",
    },
    {key: "thin_film", label: "Thin Film", value: "Thin Film"},
    {key: "tin", label: "Tin", value: "Tin"},
    {key: "titanium", label: "Titanium", value: "Titanium"},
    {key: "tool_steel", label: "Tool Steel", value: "Tool Steel"},
    {key: "torlon_4203", label: "Torlon 4203", value: "Torlon 4203"},
    {key: "torlon_4301", label: "Torlon 4301", value: "Torlon 4301"},
    {key: "tungsten", label: "Tungsten", value: "Tungsten"},
    {key: "turcite", label: "Turcite", value: "Turcite"},
    {
      key: "uhmw",
      label: "UHMW (Ultra High Molecular Weight)",
      value: "UHMW (Ultra High Molecular Weight)",
    },
    {key: "urethane", label: "Urethane", value: "Urethane"},
    {key: "viton", label: "Viton", value: "Viton"},
    {key: "viton_extreme", label: "Viton Extreme", value: "Viton Extreme"},
    {key: "walnut", label: "Walnut", value: "Walnut"},
    {key: "walnut_shell", label: "Walnut Shell", value: "Walnut Shell"},
    {
      key: "white_high_impact_styrene",
      label: "White High-impact Styrene",
      value: "White High-impact Styrene",
    },
    {key: "willow", label: "Willow", value: "Willow"},
    {key: "wire_wound", label: "Wire Wound", value: "Wire Wound"},
    {key: "wood", label: "Wood", value: "Wood"},
    {key: "wood_laminate", label: "Wood Laminate", value: "Wood Laminate"},
    {key: "wool", label: "Wool", value: "Wool"},
    {key: "zinc", label: "Zinc", value: "Zinc"},
    {key: "zirconia", label: "Zirconia", value: "Zirconia"},
    {
      key: "zirconia_alumina",
      label: "Zirconia Alumina",
      value: "Zirconia Alumina",
    },
    {
      key: "zirconia_alumina_aluminum_oxide",
      label: "Zirconia Alumina-Aluminum Oxide",
      value: "Zirconia Alumina-Aluminum Oxide",
    },
    {
      key: "zirconia_alumina_silicon_carbide",
      label: "Zirconia Alumina-Silicon Carbide",
      value: "Zirconia Alumina-Silicon Carbide",
    },
    {
      key: "zirkon_aluminum",
      label: "Zirkon Aluminum",
      value: "Zirkon Aluminum",
    },
  ],
  finish_type: [
    {key: "Finished", label: "Finished", value: "Finished"},
    {key: "Glossy", label: "Glossy", value: "Glossy"},
    {key: "Hand-Scraped", label: "Hand-Scraped", value: "Hand-Scraped"},
    {
      key: "High Speed Steel",
      label: "High Speed Steel",
      value: "High Speed Steel",
    },
    {key: "Matte", label: "Matte", value: "Matte"},
    {key: "Polished", label: "Polished", value: "Polished"},
    {
      key: "Stainless-Steel",
      label: "Stainless-Steel",
      value: "Stainless-Steel",
    },
    {key: "Tialn", label: "Tialn", value: "Tialn"},
    {key: "TiCN", label: "TiCN", value: "TiCN"},
    {key: "Uncoated", label: "Uncoated", value: "Uncoated"},
    {key: "Zinc Plated", label: "Zinc Plated", value: "Zinc Plated"},
    {key: "Cast", label: "Cast", value: "Cast"},
    {key: "Coated", label: "Coated", value: "Coated"},
    {key: "Antique", label: "Antique", value: "Antique"},
    {key: "Biscuit", label: "Biscuit", value: "Biscuit"},
    {key: "Brass", label: "Brass", value: "Brass"},
    {key: "Unfinished", label: "Unfinished", value: "Unfinished"},
    {key: "Iron", label: "Iron", value: "Iron"},
    {key: "Machined", label: "Machined", value: "Machined"},
    {key: "Cobalt", label: "Cobalt", value: "Cobalt"},
    {key: "Silk", label: "Silk", value: "Silk"},
    {key: "Satin", label: "Satin", value: "Satin"},
    {key: "Pewter", label: "Pewter", value: "Pewter"},
    {key: "TiN", label: "TiN", value: "TiN"},
    {key: "Chrome", label: "Chrome", value: "Chrome"},
    {key: "Limewash", label: "Limewash", value: "Limewash"},
    {
      key: "Tungsten Carbide",
      label: "Tungsten Carbide",
      value: "Tungsten Carbide",
    },
    {key: "Copper", label: "Copper", value: "Copper"},
    {key: "Stainless", label: "Stainless", value: "Stainless"},
    {key: "Venetian", label: "Venetian", value: "Venetian"},
    {key: "Bronze", label: "Bronze", value: "Bronze"},
    {key: "Brushed Bronze", label: "Brushed Bronze", value: "Brushed Bronze"},
    {key: "Gold", label: "Gold", value: "Gold"},
    {key: "TiB2", label: "TiB2", value: "TiB2"},
    {key: "Multiple", label: "Multiple", value: "Multiple"},
    {key: "Stamped", label: "Stamped", value: "Stamped"},
    {key: "Brushed Nickel", label: "Brushed Nickel", value: "Brushed Nickel"},
    {key: "AlTiN", label: "AlTiN", value: "AlTiN"},
    {key: "Brushed Chrome", label: "Brushed Chrome", value: "Brushed Chrome"},
    {key: "Masonry", label: "Masonry", value: "Masonry"},
    {key: "Steel", label: "Steel", value: "Steel"},
    {key: "Eggshell", label: "Eggshell", value: "Eggshell"},
    {key: "Silver", label: "Silver", value: "Silver"},
    {key: "TiSiN", label: "TiSiN", value: "TiSiN"},
    {key: "Metallic", label: "Metallic", value: "Metallic"},
    {key: "Mixed", label: "Mixed", value: "Mixed"},
    {key: "Ceramic", label: "Ceramic", value: "Ceramic"},
    {key: "Nickel", label: "Nickel", value: "Nickel"},
    {key: "Brushed Brass", label: "Brushed Brass", value: "Brushed Brass"},
    {key: "Brushed Steel", label: "Brushed Steel", value: "Brushed Steel"},
    {key: "Painted", label: "Painted", value: "Painted"},
    {key: "Polished Brass", label: "Polished Brass", value: "Polished Brass"},
    {
      key: "Polished Chrome",
      label: "Polished Chrome",
      value: "Polished Chrome",
    },
    {key: "Polished Steel", label: "Polished Steel", value: "Polished Steel"},
    {key: "Intelligent", label: "Intelligent", value: "Intelligent"},
    {key: "Hand Scraped", label: "Hand Scraped", value: "Hand Scraped"},
  ],
  plug_type: [
    {
      key: "A",
      label: "A - Two flat parallel plugs. American type.",
      value: "A",
    },
    {
      key: "B",
      label:
        "B - Two flat parallel plugs with ground plug. American type with ground plug.",
      value: "B",
    },
    {key: "C", label: "C - Two round plugs. French type.", value: "C"},
    {
      key: "D",
      label:
        "D - Two round plugs with ground plug. French type with ground plug.",
      value: "D",
    },
    {
      key: "E",
      label: "E - Two round plugs with male ground plug.",
      value: "E",
    },
    {key: "F", label: "F - Schuko type with two ground plugs.", value: "F"},
    {key: "G", label: "G - Square plugs. British type.", value: "G"},
    {key: "H", label: "H - V plugs with ground plug.", value: "H"},
    {key: "I", label: "I - Inversed V plugs with ground plug.", value: "I"},
    {key: "J", label: "J - Round plug with ground plug.", value: "J"},
    {
      key: "K",
      label: "K - Plug-in plugs: rectangular with ground plug.",
      value: "K",
    },
    {
      key: "L",
      label: "L - Round plugs with aligned ground plug.",
      value: "L",
    },
    {
      key: "M",
      label: "M - Two large round plugs with ground plug.",
      value: "M",
    },
  ],
  special_features: [
    {key: "Auto on/off", label: "Auto on/off", value: "Auto on/off"},
    {key: "Built in timer", label: "Built in timer", value: "Built in timer"},
    {key: "Dimmable", label: "Dimmable", value: "Dimmable"},
    {key: "Lap timer", label: "Lap timer", value: "Lap timer"},
    {
      key: "Back up battery",
      label: "Back up battery",
      value: "Back up battery",
    },
    {key: "Bike computer", label: "Bike computer", value: "Bike computer"},
    {key: "Calculator", label: "Calculator", value: "Calculator"},
    {key: "Chronograph", label: "Chronograph", value: "Chronograph"},
    {key: "Compass GPS", label: "Compass GPS", value: "Compass GPS"},
    {
      key: "Depth measurement",
      label: "Depth measurement",
      value: "Depth measurement",
    },
    {
      key: "Dual time display",
      label: "Dual time display",
      value: "Dual time display",
    },
    {
      key: "Heart rate monitor",
      label: "Heart rate monitor",
      value: "Heart rate monitor",
    },
    {key: "Light", label: "Light", value: "Light"},
    {key: "Luminous", label: "Luminous", value: "Luminous"},
    {
      key: "Outdoor computer",
      label: "Outdoor computer",
      value: "Outdoor computer",
    },
    {
      key: "Radio Controlled",
      label: "Radio Controlled",
      value: "Radio Controlled",
    },
    {
      key: "Screw down crown",
      label: "Screw down crown",
      value: "Screw down crown",
    },
    {key: "Second hand", label: "Second hand", value: "Second hand"},
    {
      key: "Shock resistant",
      label: "Shock resistant",
      value: "Shock resistant",
    },
    {key: "Slide rule", label: "Slide rule", value: "Slide rule"},
    {key: "Stop watch", label: "Stop watch", value: "Stop watch"},
    {key: "Tachometer", label: "Tachometer", value: "Tachometer"},
    {key: "Timer", label: "Timer", value: "Timer"},
    {key: "World time", label: "World time", value: "World time"},
    {
      key: "20 degree wire colated",
      label: "20 degree wire colated",
      value: "20 degree wire colated",
    },
    {
      key: "28 degree plastic coated",
      label: "28 degree plastic coated",
      value: "28 degree plastic coated",
    },
    {
      key: "32 degree paper colated",
      label: "32 degree paper colated",
      value: "32 degree paper colated",
    },
    {
      key: "adjustable shoe",
      label: "adjustable shoe",
      value: "adjustable shoe",
    },
    {
      key: "Air inlet thread size (NPT)",
      label: "Air inlet thread size (NPT)",
      value: "Air inlet thread size (NPT)",
    },
    {key: "Bell", label: "Bell", value: "Bell"},
    {key: "Carbide height", label: "Carbide height", value: "Carbide height"},
    {key: "Contact points", label: "Contact points", value: "Contact points"},
    {
      key: "Diode 635 nanometers",
      label: "Diode 635 nanometers",
      value: "Diode 635 nanometers",
    },
    {
      key: "Dust collection",
      label: "Dust collection",
      value: "Dust collection",
    },
    {
      key: "Dust cycle percentage",
      label: "Dust cycle percentage",
      value: "Dust cycle percentage",
    },
    {
      key: "Dust cycle time",
      label: "Dust cycle time",
      value: "Dust cycle time",
    },
    {key: "Electric brake", label: "Electric brake", value: "Electric brake"},
    {key: "Electrical", label: "Electrical", value: "Electrical"},
    {
      key: "Electrode thickness 1/4 inch",
      label: "Electrode thickness 1/4 inch",
      value: "Electrode thickness 1/4 inch",
    },
    {
      key: "Electrode type copper",
      label: "Electrode type copper",
      value: "Electrode type copper",
    },
    {
      key: "Electrode type mild steel",
      label: "Electrode type mild steel",
      value: "Electrode type mild steel",
    },
    {key: "Extra height", label: "Extra height", value: "Extra height"},
    {key: "Flag", label: "Flag", value: "Flag"},
    {key: "Hose size", label: "Hose size", value: "Hose size"},
    {
      key: "Impact resistance",
      label: "Impact resistance",
      value: "Impact resistance",
    },
    {
      key: "Keyless features",
      label: "Keyless features",
      value: "Keyless features",
    },
    {key: "Latch throw", label: "Latch throw", value: "Latch throw"},
    {
      key: "Lighting interface",
      label: "Lighting interface",
      value: "Lighting interface",
    },
    {key: "Lockable", label: "Lockable", value: "Lockable"},
    {key: "Magnetic", label: "Magnetic", value: "Magnetic"},
    {key: "Mute", label: "Mute", value: "Mute"},
    {key: "Name plate", label: "Name plate", value: "Name plate"},
    {key: "Newspaper roll", label: "Newspaper roll", value: "Newspaper roll"},
    {key: "Night vision", label: "Night vision", value: "Night vision"},
    {key: "Orbital action", label: "Orbital action", value: "Orbital action"},
    {key: "Outlets", label: "Outlets", value: "Outlets"},
    {key: "Paintable", label: "Paintable", value: "Paintable"},
    {key: "Panic button", label: "Panic button", value: "Panic button"},
    {key: "Portable", label: "Portable", value: "Portable"},
    {key: "Positive stop", label: "Positive stop", value: "Positive stop"},
    {
      key: "Rechargeable battery",
      label: "Rechargeable battery",
      value: "Rechargeable battery",
    },
    {key: "Removable", label: "Removable", value: "Removable"},
    {
      key: "Self Ttghtening",
      label: "Self Ttghtening",
      value: "Self Ttghtening",
    },
    {key: "Variable speed", label: "Variable speed", value: "Variable speed"},
    {key: "Video", label: "Video", value: "Video"},
    {key: "Washable", label: "Washable", value: "Washable"},
    {key: "Waterproof", label: "Waterproof", value: "Waterproof"},
    {key: "Wheels", label: "Wheels", value: "Wheels"},
    {key: "Wireless", label: "Wireless", value: "Wireless"},
    {
      key: "2-way switching",
      label: "2-way switching",
      value: "2-way switching",
    },
    {
      key: "Shatter resistant",
      label: "Shatter resistant",
      value: "Shatter resistant",
    },
    {
      key: "Shock and vibration resistant",
      label: "Shock and vibration resistant",
      value: "Shock and vibration resistant",
    },
    {
      key: "Non bug attracting",
      label: "Non bug attracting",
      value: "Non bug attracting",
    },
    {
      key: "3 way switching",
      label: "3 way switching",
      value: "3 way switching",
    },
  ],
  item_weight_unit_of_measure: [
    {key: "pound_(lb)", label: "Pound (LB)", value: "Pound (LB)"},
    {key: "kilogram_(kg)", label: "Kilogram (KG)", value: "Kilogram (KG)"},
    {key: "gram_(gr)", label: "Gram (GR)", value: "Gram (GR)"},
    {
      key: "hundredths_pounds",
      label: "Hundredths pounds",
      value: "Hundredths pounds",
    },
    {key: "milligram_(mg)", label: "Milligram (MG)", value: "Milligram (MG)"},
    {key: "tons", label: "Tons", value: "Tons"},
    {key: "ounce_(oz)", label: "Ounce (OZ)", value: "Ounce (OZ)"},
  ],
  item_volume_unit_of_measure: [
    {key: "cup", label: "Cup", value: "Cup"},
    {key: "microliters", label: "Microliters", value: "Microliters"},
    {key: "cubic-ft", label: "Cubic Feet", value: "Cubic Feet"},
    {key: "centiliters", label: "Centiliters", value: "Centiliters"},
    {key: "gallon", label: "Gallon", value: "Gallon"},
    {key: "quarts", label: "Quarts", value: "Quarts"},
    {key: "nanoliters", label: "Nanoliters", value: "Nanoliters"},
    {key: "liter", label: "Liter", value: "Liter"},
    {key: "picoliters", label: "Picoliters", value: "Picoliters"},
    {
      key: "unknown_modifier",
      label: "Unknown Modifier",
      value: "Unknown Modifier",
    },
    {key: "fluid_ounces", label: "Fluid Ounces", value: "Fluid Ounces"},
    {key: "cubic-m", label: "Cubic Meters", value: "Cubic Meters"},
    {key: "pints", label: "Pints", value: "Pints"},
    {key: "cubic-yd", label: "Cubic Yards", value: "Cubic Yards"},
    {key: "cubic-in", label: "Cubic Inches", value: "Cubic Inches"},
    {
      key: "imperial_gallons",
      label: "Imperial Gallons",
      value: "Imperial Gallons",
    },
    {key: "milliliter", label: "Milliliters", value: "Milliliters"},
    {key: "cubic-cm", label: "Cubic Centimeters", value: "Cubic Centimeters"},
    {key: "deciliters", label: "Deciliters", value: "Deciliters"},
  ],
  battery_type: [
    {
      key: "Battery type AA",
      value: "Battery type AA",
      label: "Battery type AA",
    },
    {
      key: "Battery type AAA",
      value: "Battery type AAA",
      label: "Battery type AAA",
    },
    {
      key: "Battery type lithium ion",
      value: "Battery type lithium ion",
      label: "Battery type lithium ion",
    },
    {key: "Battery type A", value: "Battery type A", label: "Battery type A"},
    {
      key: "Battery type CR2",
      value: "Battery type CR2",
      label: "Battery type CR2",
    },
    {key: "Battery type C", value: "Battery type C", label: "Battery type C"},
    {key: "Battery type D", value: "Battery type D", label: "Battery type D"},
    {
      key: "Battery type CR5",
      value: "Battery type CR5",
      label: "Battery type CR5",
    },
    {key: "AAAA battery", value: "AAAA battery", label: "AAAA battery"},
    {
      key: "battery type P76",
      value: "Battery type P76",
      label: "Battery type P76",
    },
    {
      key: "Battery type product specific",
      value: "Battery type product specific",
      label: "Battery type product specific",
    },
    {key: "Lithiumpolymer", value: "Lithiumpolymer", label: "Lithiumpolymer"},
    {key: "Unknown", value: "Unknown", label: "Unknown"},
    {
      key: "Battery type lithium metal",
      value: "Battery type lithium metal",
      label: "Battery type lithium metal",
    },
    {
      key: "Nonstandard battery",
      value: "Nonstandard battery",
      label: "Nonstandard battery",
    },
    {
      key: "Battery type CR123A",
      value: "Battery type CR123A",
      label: "Battery type CR123A",
    },
    {key: "lr44", value: "lr44", label: "lr44"},
    {key: "12V battery", value: "12V battery", label: "12V battery"},
    {
      key: "Battery type 9V",
      value: "Battery type 9V",
      label: "Battery type 9V",
    },
  ],
  warranty_term: [
    {
      key: "3 months warranty",
      label: "3 months warranty",
      value: "3 months warranty",
    },
    {
      key: "4 months warranty",
      label: "4 months warranty",
      value: "4 months warranty",
    },
    {
      key: "5 months warranty",
      label: "5 months warranty",
      value: "5 months warranty",
    },
    {
      key: "6 months warranty",
      label: "6 months warranty",
      value: "6 months warranty",
    },
    {
      key: "7 months warranty",
      label: "7 months warranty",
      value: "7 months warranty",
    },
    {
      key: "8 months warranty",
      label: "8 months warranty",
      value: "8 months warranty",
    },
    {
      key: "9 months warranty",
      label: "9 months warranty",
      value: "9 months warranty",
    },
    {
      key: "10 months warranty",
      label: "10 months warranty",
      value: "10 months warranty",
    },
    {
      key: "11 months warranty",
      label: "11 months warranty",
      value: "11 months warranty",
    },
    {
      key: "1 year warranty",
      label: "1 year warranty",
      value: "1 year warranty",
    },
    {
      key: "2 years warranty",
      label: "2 years warranty",
      value: "2 years warranty",
    },
    {
      key: "3 years warranty",
      label: "3 years warranty",
      value: "3 years warranty",
    },
    {
      key: "4 years warranty",
      label: "4 years warranty",
      value: "4 years warranty",
    },
    {
      key: "5 years warranty",
      label: "5 years warranty",
      value: "5 years warranty",
    },
    {
      key: "6 years warranty",
      label: "6 years warranty",
      value: "6 years warranty",
    },
    {
      key: "7 years warranty",
      label: "7 years warranty",
      value: "7 years warranty",
    },
    {
      key: "8 years warranty",
      label: "8 years warranty",
      value: "8 years warranty",
    },
    {
      key: "9 years warranty",
      label: "9 years warranty",
      value: "9 years warranty",
    },
    {
      key: "10 years warranty",
      label: "10 years warranty",
      value: "10 years warranty",
    },
    {
      key: "11 years warranty",
      label: "11 years warranty",
      value: "11 years warranty",
    },
    {
      key: "12 years warranty",
      label: "12 years warranty",
      value: "12 years warranty",
    },
    {
      key: "13 years warranty",
      label: "13 years warranty",
      value: "13 years warranty",
    },
    {
      key: "14 years warranty",
      label: "14 years warranty",
      value: "14 years warranty",
    },
    {
      key: "15 years warranty",
      label: "15 years warranty",
      value: "15 years warranty",
    },
    {
      key: "Lifetime warranty",
      label: "Lifetime warranty",
      value: "Lifetime warranty",
    },
    {
      key: "13 months warranty",
      label: "13 months warranty",
      value: "13 months warranty",
    },
    {
      key: "14 months warranty",
      label: "14 months warranty",
      value: "14 months warranty",
    },
    {
      key: "15 months warranty",
      label: "15 months warranty",
      value: "15 months warranty",
    },
    {
      key: "16 months warranty",
      label: "16 months warranty",
      value: "16 months warranty",
    },
    {
      key: "17 months warranty",
      label: "17 months warranty",
      value: "17 months warranty",
    },
    {
      key: "18 months warranty",
      label: "18 months warranty",
      value: "18 months warranty",
    },
    {
      key: "19 months warranty",
      label: "19 months warranty",
      value: "19 months warranty",
    },
    {
      key: "20 months warranty",
      label: "20 months warranty",
      value: "20 months warranty",
    },
    {
      key: "21 months warranty",
      label: "21 months warranty",
      value: "21 months warranty",
    },
    {
      key: "22 months warranty",
      label: "22 months warranty",
      value: "22 months warranty",
    },
    {
      key: "23 months warranty",
      label: "23 months warranty",
      value: "23 months warranty",
    },
  ],
  return_refund_criteria: [
    {
      key: "7 days free return",
      label: "7 days free return",
      value: "7 days free return",
    },
    {
      key: "No return or refund",
      label: "No return or refund",
      value: "no return or refund",
    },
    {
      key: "14 days free return",
      label: "14 days free return",
      value: "14 days free return",
    },
    {
      key: "30 days free return",
      label: "30 days free return",
      value: "30 days free return",
    },
  ],
  "Comission Percent": [
    0.15, 0.1, 0.075, 0.05, 0.03, 0.3, 0.29, 0.28, 0.27, 0.26, 0.25, 0.24, 0.23,
    0.22, 0.21, 0.2, 0.19, 0.18, 0.17, 0.16, 0.14, 0.13, 0.12, 0.11, 0.09, 0.08,
    0.07, 0.06, 0.04,
  ],
  "MOB cities": [
    "Chennai",
    "Hyderabad",
    "Delhi NCR",
    "Bengaluru",
    "Mumbai",
    "Kochi",
    "Jaipur",
    "Chandigarh",
    "Coimbatore",
    "Goa",
    "Kolkata",
    "Mysore",
  ],
  "MOB personnel name ID": [
    "Kumar Vivek (0001)",
    "Johann Elias Terfurth (0002)",
  ],
  variation_theme: [
    {key: "width", label: "Width", value: "Width"},
    {key: "display_weight", label: "Display weight", value: "Display weight"},
    {
      key: "number_of_items",
      label: "Number of items",
      value: "Number of items",
    },
    {
      key: "color_name_+_number_of_items",
      label: "Color name + number of items",
      value: "Color name + number of items",
    },
    {
      key: "size_name_+_number_of_items",
      label: "Size name + number of items",
      value: "Size name + number of items",
    },
    {key: "material", label: "Material", value: "Material"},
    {
      key: "material_+_size",
      label: "Material + size",
      value: "Material + size",
    },
    {key: "pattern_name", label: "Pattern name", value: "Pattern name"},
    {key: "size_name", label: "Size name", value: "Size name"},
    {
      key: "size_name_+_color_name",
      label: "Size name + color name",
      value: "Size name + color name",
    },
    {key: "display_height", label: "Display height", value: "Display height"},
    {key: "color_name", label: "Color name", value: "Color name"},
    {key: "pattern", label: "Pattern", value: "Pattern"},
    {
      key: "display_height_+_display_length",
      label: "Display height + display length",
      value: "Display height + display length",
    },
    {key: "display_length", label: "Display length", value: "Display length"},
    {key: "display_width", label: "Display width", value: "Display width"},
    {key: "volume", label: "Volume", value: "Volume"},
    {key: "colour+volume", label: "Colour+Volume", value: "Colour+Volume"},
    {key: "colour+weight", label: "Colour+Weight", value: "Colour+Weight"},
    {
      key: "display_length_+_display_width",
      label: "Display length + display width",
      value: "Display length + display width",
    },
  ],
  country: [
    {key: "Afghanistan", label: "Afghanistan", value: "Afghanistan"},
    {key: "Aland Islands", label: "Aland Islands", value: "Aland Islands"},
    {key: "Albania", label: "Albania", value: "Albania"},
    {key: "Algeria", label: "Algeria", value: "Algeria"},
    {key: "American Samoa", label: "American Samoa", value: "American Samoa"},
    {key: "Andorra", label: "Andorra", value: "Andorra"},
    {key: "Angola", label: "Angola", value: "Angola"},
    {key: "Anguilla", label: "Anguilla", value: "Anguilla"},
    {key: "Antarctica", label: "Antarctica", value: "Antarctica"},
    {
      key: "Antigua and Barbuda",
      label: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
    },
    {key: "Argentina", label: "Argentina", value: "Argentina"},
    {key: "Armenia", label: "Armenia", value: "Armenia"},
    {key: "Aruba", label: "Aruba", value: "Aruba"},
    {key: "Australia", label: "Australia", value: "Australia"},
    {key: "Austria", label: "Austria", value: "Austria"},
    {key: "Azerbaijan", label: "Azerbaijan", value: "Azerbaijan"},
    {key: "Bahamas", label: "Bahamas", value: "Bahamas"},
    {key: "Bahrain", label: "Bahrain", value: "Bahrain"},
    {key: "Bangladesh", label: "Bangladesh", value: "Bangladesh"},
    {key: "Barbados", label: "Barbados", value: "Barbados"},
    {key: "Belarus", label: "Belarus", value: "Belarus"},
    {key: "Belgium", label: "Belgium", value: "Belgium"},
    {key: "Belize", label: "Belize", value: "Belize"},
    {key: "Benin", label: "Benin", value: "Benin"},
    {key: "Bermuda", label: "Bermuda", value: "Bermuda"},
    {key: "Bhutan", label: "Bhutan", value: "Bhutan"},
    {key: "Bolivia", label: "Bolivia", value: "Bolivia"},
    {
      key: "Bosnia and Herzegovina",
      label: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
    },
    {key: "Botswana", label: "Botswana", value: "Botswana"},
    {key: "Bouvet Island", label: "Bouvet Island", value: "Bouvet Island"},
    {key: "Brazil", label: "Brazil", value: "Brazil"},
    {
      key: "British Virgin Islands",
      label: "British Virgin Islands",
      value: "British Virgin Islands",
    },
    {
      key: "British Indian Ocean Territory",
      label: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
    },
    {
      key: "Brunei Darussalam",
      label: "Brunei Darussalam",
      value: "Brunei Darussalam",
    },
    {key: "Bulgaria", label: "Bulgaria", value: "Bulgaria"},
    {key: "Burkina Faso", label: "Burkina Faso", value: "Burkina Faso"},
    {key: "Burundi", label: "Burundi", value: "Burundi"},
    {key: "Cambodia", label: "Cambodia", value: "Cambodia"},
    {key: "Cameroon", label: "Cameroon", value: "Cameroon"},
    {key: "Canada", label: "Canada", value: "Canada"},
    {key: "Cape Verde", label: "Cape Verde", value: "Cape Verde"},
    {key: "Cayman Islands", label: "Cayman Islands", value: "Cayman Islands"},
    {
      key: "Central African Republic",
      label: "Central African Republic",
      value: "Central African Republic",
    },
    {key: "Chad", label: "Chad", value: "Chad"},
    {key: "Chile", label: "Chile", value: "Chile"},
    {key: "China", label: "China", value: "China"},
    {key: "Hong Kong", label: "Hong Kong", value: "Hong Kong"},
    {key: "Macao", label: "Macao", value: "Macao"},
    {
      key: "Christmas Island",
      label: "Christmas Island",
      value: "Christmas Island",
    },
    {
      key: "Cocos (Keeling) Islands",
      label: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
    },
    {key: "Colombia", label: "Colombia", value: "Colombia"},
    {key: "Comoros", label: "Comoros", value: "Comoros"},
    {
      key: "Congo (Brazzaville)",
      label: "Congo (Brazzaville)",
      value: "Congo (Brazzaville)",
    },
    {key: "Congo", label: "Congo", value: "Congo"},
    {key: "Cook Islands", label: "Cook Islands", value: "Cook Islands"},
    {key: "Costa Rica", label: "Costa Rica", value: "Costa Rica"},
    {key: "Côte d'Ivoire", label: "Côte d'Ivoire", value: "Côte d'Ivoire"},
    {key: "Croatia", label: "Croatia", value: "Croatia"},
    {key: "Cuba", label: "Cuba", value: "Cuba"},
    {key: "Cyprus", label: "Cyprus", value: "Cyprus"},
    {key: "Czech Republic", label: "Czech Republic", value: "Czech Republic"},
    {key: "Denmark", label: "Denmark", value: "Denmark"},
    {key: "Djibouti", label: "Djibouti", value: "Djibouti"},
    {key: "Dominica", label: "Dominica", value: "Dominica"},
    {
      key: "Dominican Republic",
      label: "Dominican Republic",
      value: "Dominican Republic",
    },
    {key: "Ecuador", label: "Ecuador", value: "Ecuador"},
    {key: "Egypt", label: "Egypt", value: "Egypt"},
    {key: "El Salvador", label: "El Salvador", value: "El Salvador"},
    {
      key: "Equatorial Guinea",
      label: "Equatorial Guinea",
      value: "Equatorial Guinea",
    },
    {key: "Eritrea", label: "Eritrea", value: "Eritrea"},
    {key: "Estonia", label: "Estonia", value: "Estonia"},
    {key: "Ethiopia", label: "Ethiopia", value: "Ethiopia"},
    {
      key: "Falkland Islands (Malvinas)",
      label: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
    },
    {key: "Faroe Islands", label: "Faroe Islands", value: "Faroe Islands"},
    {key: "Fiji", label: "Fiji", value: "Fiji"},
    {key: "Finland", label: "Finland", value: "Finland"},
    {key: "France", label: "France", value: "France"},
    {key: "French Guiana", label: "French Guiana", value: "French Guiana"},
    {
      key: "French Polynesia",
      label: "French Polynesia",
      value: "French Polynesia",
    },
    {
      key: "French Southern Territories",
      label: "French Southern Territories",
      value: "French Southern Territories",
    },
    {key: "Gabon", label: "Gabon", value: "Gabon"},
    {key: "Gambia", label: "Gambia", value: "Gambia"},
    {key: "Georgia", label: "Georgia", value: "Georgia"},
    {key: "Germany", label: "Germany", value: "Germany"},
    {key: "Ghana", label: "Ghana", value: "Ghana"},
    {key: "Gibraltar", label: "Gibraltar", value: "Gibraltar"},
    {key: "Greece", label: "Greece", value: "Greece"},
    {key: "Greenland", label: "Greenland", value: "Greenland"},
    {key: "Grenada", label: "Grenada", value: "Grenada"},
    {key: "Guadeloupe", label: "Guadeloupe", value: "Guadeloupe"},
    {key: "Guam", label: "Guam", value: "Guam"},
    {key: "Guatemala", label: "Guatemala", value: "Guatemala"},
    {key: "Guernsey", label: "Guernsey", value: "Guernsey"},
    {key: "Guinea", label: "Guinea", value: "Guinea"},
    {key: "Guinea-Bissau", label: "Guinea-Bissau", value: "Guinea-Bissau"},
    {key: "Guyana", label: "Guyana", value: "Guyana"},
    {key: "Haiti", label: "Haiti", value: "Haiti"},
    {
      key: "Heard Island and Mcdonald Islands",
      label: "Heard Island and Mcdonald Islands",
      value: "Heard Island and Mcdonald Islands",
    },
    {
      key: "Holy See (Vatican City State)",
      label: "Holy See (Vatican City State)",
      value: "Holy See (Vatican City State)",
    },
    {key: "Honduras", label: "Honduras", value: "Honduras"},
    {key: "Hungary", label: "Hungary", value: "Hungary"},
    {key: "Iceland", label: "Iceland", value: "Iceland"},
    {key: "India", label: "India", value: "India"},
    {key: "Indonesia", label: "Indonesia", value: "Indonesia"},
    {key: "Iran", label: "Iran", value: "Iran"},
    {key: "Iraq", label: "Iraq", value: "Iraq"},
    {key: "Ireland", label: "Ireland", value: "Ireland"},
    {key: "Isle of Man", label: "Isle of Man", value: "Isle of Man"},
    {key: "Israel", label: "Israel", value: "Israel"},
    {key: "Italy", label: "Italy", value: "Italy"},
    {key: "Jamaica", label: "Jamaica", value: "Jamaica"},
    {key: "Japan", label: "Japan", value: "Japan"},
    {key: "Jersey", label: "Jersey", value: "Jersey"},
    {key: "Jordan", label: "Jordan", value: "Jordan"},
    {key: "Kazakhstan", label: "Kazakhstan", value: "Kazakhstan"},
    {key: "Kenya", label: "Kenya", value: "Kenya"},
    {key: "Kiribati", label: "Kiribati", value: "Kiribati"},
    {key: "North Korea", label: "North Korea", value: "North Korea"},
    {key: "South Korea", label: "South Korea", value: "South Korea"},
    {key: "Kuwait", label: "Kuwait", value: "Kuwait"},
    {key: "Kyrgyzstan", label: "Kyrgyzstan", value: "Kyrgyzstan"},
    {key: "Lao PDR", label: "Lao PDR", value: "Lao PDR"},
    {key: "Latvia", label: "Latvia", value: "Latvia"},
    {key: "Lebanon", label: "Lebanon", value: "Lebanon"},
    {key: "Lesotho", label: "Lesotho", value: "Lesotho"},
    {key: "Liberia", label: "Liberia", value: "Liberia"},
    {key: "Libya", label: "Libya", value: "Libya"},
    {key: "Liechtenstein", label: "Liechtenstein", value: "Liechtenstein"},
    {key: "Lithuania", label: "Lithuania", value: "Lithuania"},
    {key: "Luxembourg", label: "Luxembourg", value: "Luxembourg"},
    {key: "Macedonia", label: "Macedonia", value: "Macedonia"},
    {key: "Madagascar", label: "Madagascar", value: "Madagascar"},
    {key: "Malawi", label: "Malawi", value: "Malawi"},
    {key: "Malaysia", label: "Malaysia", value: "Malaysia"},
    {key: "Maldives", label: "Maldives", value: "Maldives"},
    {key: "Mali", label: "Mali", value: "Mali"},
    {key: "Malta", label: "Malta", value: "Malta"},
    {
      key: "Marshall Islands",
      label: "Marshall Islands",
      value: "Marshall Islands",
    },
    {key: "Martinique", label: "Martinique", value: "Martinique"},
    {key: "Mauritania", label: "Mauritania", value: "Mauritania"},
    {key: "Mauritius", label: "Mauritius", value: "Mauritius"},
    {key: "Mayotte", label: "Mayotte", value: "Mayotte"},
    {key: "Mexico", label: "Mexico", value: "Mexico"},
    {key: "Micronesia", label: "Micronesia", value: "Micronesia"},
    {key: "Moldova", label: "Moldova", value: "Moldova"},
    {key: "Monaco", label: "Monaco", value: "Monaco"},
    {key: "Mongolia", label: "Mongolia", value: "Mongolia"},
    {key: "Montenegro", label: "Montenegro", value: "Montenegro"},
    {key: "Montserrat", label: "Montserrat", value: "Montserrat"},
    {key: "Morocco", label: "Morocco", value: "Morocco"},
    {key: "Mozambique", label: "Mozambique", value: "Mozambique"},
    {key: "Myanmar", label: "Myanmar", value: "Myanmar"},
    {key: "Namibia", label: "Namibia", value: "Namibia"},
    {key: "Nauru", label: "Nauru", value: "Nauru"},
    {key: "Nepal", label: "Nepal", value: "Nepal"},
    {key: "Netherlands", label: "Netherlands", value: "Netherlands"},
    {
      key: "Netherlands Antilles",
      label: "Netherlands Antilles",
      value: "Netherlands Antilles",
    },
    {key: "New Caledonia", label: "New Caledonia", value: "New Caledonia"},
    {key: "New Zealand", label: "New Zealand", value: "New Zealand"},
    {key: "Nicaragua", label: "Nicaragua", value: "Nicaragua"},
    {key: "Niger", label: "Niger", value: "Niger"},
    {key: "Nigeria", label: "Nigeria", value: "Nigeria"},
    {key: "Niue", label: "Niue", value: "Niue"},
    {key: "Norfolk Island", label: "Norfolk Island", value: "Norfolk Island"},
    {
      key: "Northern Mariana Islands",
      label: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
    },
    {key: "Norway", label: "Norway", value: "Norway"},
    {key: "Oman", label: "Oman", value: "Oman"},
    {key: "Pakistan", label: "Pakistan", value: "Pakistan"},
    {key: "Palau", label: "Palau", value: "Palau"},
    {key: "Palestine", label: "Palestine", value: "Palestine"},
    {key: "Panama", label: "Panama", value: "Panama"},
    {
      key: "Papua New Guinea",
      label: "Papua New Guinea",
      value: "Papua New Guinea",
    },
    {key: "Paraguay", label: "Paraguay", value: "Paraguay"},
    {key: "Peru", label: "Peru", value: "Peru"},
    {key: "Philippines", label: "Philippines", value: "Philippines"},
    {key: "Pitcairn", label: "Pitcairn", value: "Pitcairn"},
    {key: "Poland", label: "Poland", value: "Poland"},
    {key: "Portugal", label: "Portugal", value: "Portugal"},
    {key: "Puerto Rico", label: "Puerto Rico", value: "Puerto Rico"},
    {key: "Qatar", label: "Qatar", value: "Qatar"},
    {key: "Réunion", label: "Réunion", value: "Réunion"},
    {key: "Romania", label: "Romania", value: "Romania"},
    {key: "Russia", label: "Russia", value: "Russia"},
    {key: "Rwanda", label: "Rwanda", value: "Rwanda"},
    {
      key: "Saint-Barthélemy",
      label: "Saint-Barthélemy",
      value: "Saint-Barthélemy",
    },
    {key: "Saint Helena", label: "Saint Helena", value: "Saint Helena"},
    {
      key: "Saint Kitts and Nevis",
      label: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
    },
    {key: "Saint Lucia", label: "Saint Lucia", value: "Saint Lucia"},
    {
      key: "Saint-Martin (French part)",
      label: "Saint-Martin (French part)",
      value: "Saint-Martin (French part)",
    },
    {
      key: "Saint Pierre and Miquelon",
      label: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
    },
    {
      key: "Saint Vincent and Grenadines",
      label: "Saint Vincent and Grenadines",
      value: "Saint Vincent and Grenadines",
    },
    {key: "Samoa", label: "Samoa", value: "Samoa"},
    {key: "San Marino", label: "San Marino", value: "San Marino"},
    {
      key: "Sao Tome and Principe",
      label: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
    },
    {key: "Saudi Arabia", label: "Saudi Arabia", value: "Saudi Arabia"},
    {key: "Senegal", label: "Senegal", value: "Senegal"},
    {key: "Serbia", label: "Serbia", value: "Serbia"},
    {key: "Seychelles", label: "Seychelles", value: "Seychelles"},
    {key: "Sierra Leone", label: "Sierra Leone", value: "Sierra Leone"},
    {key: "Singapore", label: "Singapore", value: "Singapore"},
    {key: "Slovakia", label: "Slovakia", value: "Slovakia"},
    {key: "Slovenia", label: "Slovenia", value: "Slovenia"},
    {
      key: "Solomon Islands",
      label: "Solomon Islands",
      value: "Solomon Islands",
    },
    {key: "Somalia", label: "Somalia", value: "Somalia"},
    {key: "South Africa", label: "South Africa", value: "South Africa"},
    {
      key: "South Georgia and the South Sandwich Islands",
      label: "South Georgia and the South Sandwich Islands",
      value: "South Georgia and the South Sandwich Islands",
    },
    {key: "South Sudan", label: "South Sudan", value: "South Sudan"},
    {key: "Spain", label: "Spain", value: "Spain"},
    {key: "Sri Lanka", label: "Sri Lanka", value: "Sri Lanka"},
    {key: "Sudan", label: "Sudan", value: "Sudan"},
    {key: "Suriname", label: "Suriname", value: "Suriname"},
    {
      key: "Svalbard and Jan Mayen Islands",
      label: "Svalbard and Jan Mayen Islands",
      value: "Svalbard and Jan Mayen Islands",
    },
    {key: "Swaziland", label: "Swaziland", value: "Swaziland"},
    {key: "Sweden", label: "Sweden", value: "Sweden"},
    {key: "Switzerland", label: "Switzerland", value: "Switzerland"},
    {
      key: "Syrian Arab Republic (Syria)",
      label: "Syrian Arab Republic (Syria)",
      value: "Syrian Arab Republic (Syria)",
    },
    {key: "Taiwan", label: "Taiwan", value: "Taiwan"},
    {key: "Tajikistan", label: "Tajikistan", value: "Tajikistan"},
    {key: "Tanzania", label: "Tanzania", value: "Tanzania"},
    {key: "Thailand", label: "Thailand", value: "Thailand"},
    {key: "Timor-Leste", label: "Timor-Leste", value: "Timor-Leste"},
    {key: "Togo", label: "Togo", value: "Togo"},
    {key: "Tokelau", label: "Tokelau", value: "Tokelau"},
    {key: "Tonga", label: "Tonga", value: "Tonga"},
    {
      key: "Trinidad and Tobago",
      label: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
    },
    {key: "Tunisia", label: "Tunisia", value: "Tunisia"},
    {key: "Turkey", label: "Turkey", value: "Turkey"},
    {key: "Turkmenistan", label: "Turkmenistan", value: "Turkmenistan"},
    {
      key: "Turks and Caicos Islands",
      label: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
    },
    {key: "Tuvalu", label: "Tuvalu", value: "Tuvalu"},
    {key: "Uganda", label: "Uganda", value: "Uganda"},
    {key: "Ukraine", label: "Ukraine", value: "Ukraine"},
    {
      key: "United Arab Emirates",
      label: "United Arab Emirates",
      value: "United Arab Emirates",
    },
    {key: "United Kingdom", label: "United Kingdom", value: "United Kingdom"},
    {key: "USA", label: "USA", value: "USA"},
    {
      key: "United States Minor Outlying Islands",
      label: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
    },
    {key: "Uruguay", label: "Uruguay", value: "Uruguay"},
    {key: "Uzbekistan", label: "Uzbekistan", value: "Uzbekistan"},
    {key: "Vanuatu", label: "Vanuatu", value: "Vanuatu"},
    {key: "Venezuela", label: "Venezuela", value: "Venezuela"},
    {key: "Vietnam", label: "Vietnam", value: "Vietnam"},
    {
      key: "Virgin Islands, US",
      label: "Virgin Islands, US",
      value: "Virgin Islands, US",
    },
    {
      key: "Wallis and Futuna Islands",
      label: "Wallis and Futuna Islands",
      value: "Wallis and Futuna Islands",
    },
    {key: "Western Sahara", label: "Western Sahara", value: "Western Sahara"},
    {key: "Yemen", label: "Yemen", value: "Yemen"},
    {key: "Zambia", label: "Zambia", value: "Zambia"},
    {key: "Zimbabwe", label: "Zimbabwe", value: "Zimbabwe"},
    {key: "Kosovo", label: "Kosovo", value: "Kosovo"},
    {key: "Scotland", label: "Scotland", value: "Scotland"},
    {key: "Wales", label: "Wales", value: "Wales"},
    {
      key: "Saint Vincent And The Grenadines",
      label: "Saint Vincent And The Grenadines",
      value: "Saint Vincent And The Grenadines",
    },
  ],
  "Fulfillment latency for shipping": [
    "on-demand (< 30mins)",
    "Same day (>2 hour)",
    "Next day ",
    "2 days",
    "Up to 1 week",
    "More than 1 week",
    "Built to order (1 week)",
    "Built to order (2 weeks)",
    "Built to order (1 month)",
    "To be quoted upon request",
  ],
  unit_count_type: [
    {key: "Set", label: "Set", value: "Set"},
    {key: "Unit", label: "Unit", value: "Unit"},
    {key: "Count", label: "Count", value: "Count"},
  ],
  item_width_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  item_length_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  item_height_unit_of_measure: [
    {key: "angstrom", label: "Angstrom", value: "Angstrom"},
    {
      key: "millimeter_(mm)",
      label: "Millimeter (MM)",
      value: "Millimeter (MM)",
    },
    {key: "yards", label: "Yards", value: "Yards"},
    {key: "picometre", label: "Picometre", value: "Picometre"},
    {key: "miles", label: "Miles", value: "Miles"},
    {key: "decimetres", label: "Decimetres", value: "Decimetres"},
    {key: "meter_(m)", label: "Meter (M)", value: "Meter (M)"},
    {key: "inch_(in)", label: "Inch (IN)", value: "Inch (IN)"},
    {key: "feet_(ft)", label: "Feet (FT)", value: "Feet (FT)"},
    {
      key: "centimeter_(cm)",
      label: "Centimeter (CM)",
      value: "Centimeter (CM)",
    },
    {
      key: "hundredths-inches",
      label: "Hundredths-Inches",
      value: "Hundredths-Inches",
    },
    {key: "nanometre", label: "Nanometre", value: "Nanometre"},
    {key: "micron", label: "Micron", value: "Micron"},
    {key: "kilometres", label: "Kilometres", value: "Kilometres"},
  ],
  conditon_type: [
    {key: "New", label: "New", value: "New"},
    {
      key: "Used - like new",
      label: "Used - like new",
      value: "Used - like new",
    },
    {
      key: "Used - very good",
      label: "Used - very good",
      value: "Used - very good",
    },
    {key: "Used - good", label: "Used - good", value: "Used - good"},
    {
      key: "Used - acceptable",
      label: "Used - acceptable",
      value: "Used - acceptable",
    },
  ],
  currency: [
    {key: "INR", label: "Indian Rupee (INR)", value: "INR"},
    {key: "MXN", label: "Mexican Peso (MXN)", value: "MXN"},
    {key: "EUR", label: "Euro (EUR)", value: "EUR"},
    {key: "GBP", label: "British Pound (GBP)", value: "GBP"},
    {key: "USD", label: "United States Dollar (USD)", value: "USD"},
    {key: "CAD", label: "Canadian Dollar (CAD)", value: "CAD"},
    {key: "JPY", label: "Japanese Yen (JPY)", value: "JPY"},
    {key: "CNY", label: "Chinese Yuan (CNY)", value: "CNY"},
  ],
  variation_type: [
    {key: "parent_only", label: "Parent only", value: "Parent only"},
    {key: "variant", label: "Variant", value: "Variant"},
    {
      key: "parent_with_variant/s",
      label: "Parent with variant/s",
      value: "Parent with variant/s",
    },
  ],
  power_source_type: [
    {key: "AC", label: "AC", value: "AC"},
    {key: "AC/DC", label: "AC/DC", value: "AC/DC"},
    {key: "Air powered", label: "Air powered", value: "Air powered"},
    {
      key: "Battery powered",
      label: "Battery powered",
      value: "Battery powered",
    },
    {
      key: "Corded electric",
      label: "Corded electric",
      value: "Corded electric",
    },
    {key: "Crank", label: "Crank", value: "Crank"},
    {key: "DC", label: "DC", value: "DC"},
    {key: "Gas powered", label: "Gas powered", value: "Gas powered"},
    {key: "Hand powered", label: "Hand powered", value: "Hand powered"},
    {
      key: "Hydraulic powered",
      label: "Hydraulic powered",
      value: "Hydraulic powered",
    },
    {key: "Solar", label: "Solar", value: "Solar"},
    {key: "Fuel powered", label: "Fuel powered", value: "Fuel powered"},
    {key: "Solar powered", label: "Solar powered", value: "Solar powered"},
    {key: "Manual", label: "Manual", value: "Manual"},
  ],
  included_components: [
    {
      key: "30 minute charger",
      label: "30 minute charger",
      value: "30 minute charger",
    },
    {key: "Adapter", label: "Adapter", value: "Adapter"},
    {key: "Bag", label: "Bag", value: "Bag"},
    {key: "Batteries", label: "Batteries", value: "Batteries"},
    {key: "Blade", label: "Blade", value: "Blade"},
    {key: "Block", label: "Block", value: "Block"},
    {key: "Bolts", label: "Bolts", value: "Bolts"},
    {key: "Caps", label: "Caps", value: "Caps"},
    {key: "Caribineer", label: "Caribineer", value: "Caribineer"},
    {key: "Case", label: "Case", value: "Case"},
    {key: "Chain", label: "Chain", value: "Chain"},
    {key: "Charger", label: "Charger", value: "Charger"},
    {
      key: "Circular saw blade",
      label: "Circular saw blade",
      value: "Circular saw blade",
    },
    {
      key: "Comes as a combo set",
      label: "Comes as a combo set",
      value: "Comes as a combo set",
    },
    {
      key: "Compartments included",
      label: "Compartments included",
      value: "Compartments included",
    },
    {key: "Coupling", label: "Coupling", value: "Coupling"},
    {key: "Depth rod", label: "Depth rod", value: "Depth rod"},
    {key: "Detector", label: "Detector", value: "Detector"},
    {key: "Dowel", label: "Dowel", value: "Dowel"},
    {key: "Drill bits", label: "Drill bits", value: "Drill bits"},
    {
      key: "Drywall nosepeice",
      label: "Drywall nosepeice",
      value: "Drywall nosepeice",
    },
    {key: "Fuse", label: "Fuse", value: "Fuse"},
    {key: "Gauge", label: "Gauge", value: "Gauge"},
    {key: "Hammer", label: "Hammer", value: "Hammer"},
    {key: "Hose", label: "Hose", value: "Hose"},
    {key: "Light", label: "Light", value: "Light"},
    {key: "Motor", label: "Motor", value: "Motor"},
    {key: "Nails", label: "Nails", value: "Nails"},
    {key: "Nuts", label: "Nuts", value: "Nuts"},
    {
      key: "One hour charger",
      label: "One hour charger",
      value: "One hour charger",
    },
    {key: "Pads", label: "Pads", value: "Pads"},
    {key: "Pins", label: "Pins", value: "Pins"},
    {key: "Pocket clips", label: "Pocket clips", value: "Pocket clips"},
    {key: "Pump", label: "Pump", value: "Pump"},
    {
      key: "Quick connect fixtures",
      label: "Quick connect fixtures",
      value: "Quick connect fixtures",
    },
    {
      key: "Reciprocating saw blade",
      label: "Reciprocating saw blade",
      value: "Reciprocating saw blade",
    },
    {
      key: "Screwdriver bits",
      label: "Screwdriver bits",
      value: "Screwdriver bits",
    },
    {key: "Screws", label: "Screws", value: "Screws"},
    {
      key: "Shade protector",
      label: "Shade protector",
      value: "Shade protector",
    },
    {key: "Side handle", label: "Side handle", value: "Side handle"},
    {key: "Staples", label: "Staples", value: "Staples"},
    {
      key: "Surge protection",
      label: "Surge protection",
      value: "Surge protection",
    },
    {key: "Switch", label: "Switch", value: "Switch"},
    {key: "TEKS nosepiece", label: "TEKS nosepiece", value: "TEKS nosepiece"},
    {key: "Tacks", label: "Tacks", value: "Tacks"},
    {key: "Valve", label: "Valve", value: "Valve"},
    {key: "Washers", label: "Washers", value: "Washers"},
    {
      key: "Batteries included",
      label: "Batteries included",
      value: "Batteries included",
    },
    {key: "Bulb included", label: "Bulb included", value: "Bulb included"},
    {
      key: "Fan blade included",
      label: "Fan blade included",
      value: "Fan blade included",
    },
    {key: "Fuse", label: "Fuse", value: "Fuse"},
    {
      key: "Light kit included",
      label: "Light kit included",
      value: "Light kit included",
    },
    {key: "Shade included", label: "Shade included", value: "Shade included"},
    {
      key: "Shade protector",
      label: "Shade protector",
      value: "Shade protector",
    },
    {
      key: "Surge protection",
      label: "Surge protection",
      value: "Surge protection",
    },
    {key: "Switch", label: "Switch", value: "Switch"},
    {
      key: "Built-in water filter",
      label: "Built-in water filter",
      value: "Built-in water filter",
    },
    {key: "Toilet bowl", label: "Toilet bowl", value: "Toilet bowl"},
    {key: "Toilet tank", label: "Toilet tank", value: "Toilet tank"},
    {key: "Caribineer", label: "Caribineer", value: "Caribineer"},
    {key: "Handles", label: "Handles", value: "Handles"},
    {
      key: "Includes sidespray",
      label: "Includes sidespray",
      value: "Includes sidespray",
    },
  ],
  "Update delete": ["Update", "Partial update", "Delete"],
  "Short product description": [
    "Metal drill HSS-TiN",
    "Metal drill HHS-G",
    "Concrete drill",
    "Auger bits",
    "Spade",
    "Torx",
    "Inner square screws",
    "Depth stops",
    "Forstner bit",
    "Diamond drill",
    "Countersink drill bit",
    "Metal drill HHS-R",
    "Formwork and installation drill bits",
    "Phillips head screws",
    "Hexagon socket screws",
    "Flexible shafts",
    "Masonary drill bit",
    "Art drill",
    "Screwdriver bit sets",
    "Hinge hole drill",
    "Cross head screws",
    "Tile bit",
    "Crosspoint screws",
    "Wood drill",
    "Multi purpose drill",
    "Connectors",
    "Hammer drill",
    "Level",
    "Socket",
    "Universal holder",
    "Screwdriver bits",
    "Other",
  ],
  pattern_name: [
    {key: "a", label: "A", value: "A"},
    {key: "b", label: "B", value: "B"},
    {key: "c", label: "C", value: "C"},
    {key: "d", label: "D", value: "D"},
    {key: "e", label: "E", value: "E"},
    {key: "f", label: "F", value: "F"},
    {key: "g", label: "G", value: "G"},
    {key: "h", label: "H", value: "H"},
    {key: "i", label: "I", value: "I"},
    {key: "j", label: "J", value: "J"},
    {key: "k", label: "K", value: "K"},
    {key: "l", label: "L", value: "L"},
    {key: "m", label: "M", value: "M"},
    {key: "n", label: "N", value: "N"},
    {key: "o", label: "O", value: "O"},
    {key: "p", label: "P", value: "P"},
    {key: "q", label: "Q", value: "Q"},
    {key: "r", label: "R", value: "R"},
    {key: "s", label: "S", value: "S"},
    {key: "t", label: "T", value: "T"},
    {key: "u", label: "U", value: "U"},
    {key: "v", label: "V", value: "V"},
    {key: "w", label: "W", value: "W"},
    {key: "x", label: "X", value: "X"},
    {key: "y", label: "Y", value: "Y"},
    {key: "z", label: "Z", value: "Z"},
    {key: "0", label: "0", value: "0"},
    {key: "1", label: "1", value: "1"},
    {key: "2", label: "2", value: "2"},
    {key: "3", label: "3", value: "3"},
    {key: "4", label: "4", value: "4"},
    {key: "5", label: "5", value: "5"},
    {key: "6", label: "6", value: "6"},
    {key: "7", label: "7", value: "7"},
    {key: "8", label: "8", value: "8"},
    {key: "9", label: "9", value: "9"},
  ],
};

export const StoreSalestype = [
  {
    value: 'Storesale',
    label: 'Store sale',
  },
  {
    value: 'Stock',
    label: 'Remove from stock',
  },
 
];
// Porter Status Mapping - Maps Porter API status to UI display status
export const PORTER_STATUS_MAP = {
  open: "Requested",
  accepted: "Accepted",
  live: "Out for delivery",
  ended: "Delivered",
  cancelled: "Cancelled",
  reopened: "Requested", // Treating reopened as requested
};
